// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IBalanceReminderDto,
  ICategoryServiceDto,
  ICategorySpendLimitDto,
  ICategorySummaryDto,
  ICopayGroupDto,
  ICovTableDto,
  ICoverageDto,
  IDeductiblePreviewRequestDto,
  IDeductibleTierDto,
  IDeductibleUpdateRequestDto,
  IElectionAmountDto,
  IEnrollmentMatrixDto,
  IEnrollmentMatrixPatchDto,
  IEnumTypeDto,
  IErrorDto,
  IFundingLevelSwitchingDto,
  IGenericErrorDto,
  IHealthPlanBaseDto,
  IHealthPlanDto,
  IHealthPlanTierStatsDto,
  IHealthPolicyDto,
  IIdNameDto,
  IIrsLimitDto,
  IIrsLimitLiteDto,
  IMpTableDto,
  IOrganizationLockDto,
  IPageCopayGroupDto,
  IPageEnrollmentMatrixDto,
  IPageProcessingRuleDto,
  IPageServiceDto,
  IPageTriggerDto,
  IPageable,
  IPayoutDefinitionCreateDto,
  IPayoutDefinitionDto,
  IPayoutDefinitionPlanDto,
  IPayoutDefinitionServiceDto,
  IPayoutDefinitionUpdateDto,
  IPersonSpendLimitDto,
  IPlanCodeValidationRequestDto,
  IPlanCodeValidationResponseDto,
  IPlanDto,
  IPlanGracePeriodDto,
  IPlanIdsDto,
  IPlanPrimaryConfigLiteDto,
  IPlanReactivationDto,
  IPlanTemplateConfigDto,
  IPlanTerminationPropertiesDto,
  IPlanTerminationPropertiesPatchDto,
  IPlanYearDto,
  IPlanYearLiteDto,
  IPlanYearPlanDto,
  IPolicyElectionDto,
  IPolicyEligibleServicesDto,
  IPolicyEnrollmentDto,
  IPolicyFundIdResponseDto,
  IPolicyLimitsDto,
  IPolicySpendLimitsDto,
  IPolicyStatusDto,
  IPriorPlanDto,
  IProcessingRuleDto,
  IReducedPolicyDto,
  ISequenceDto,
  IServiceConfigDto,
  IServiceCreateDto,
  IServiceDto,
  IServiceUpdateRequest,
  ISpendLimitPeriodDto,
  ISpendLimitPeriodRemainingDto,
  ISpendLimitRemainingByAccountDto,
  ITriggerDto,
  IUpdatePayoutRuleTypeRequestDto,
  IUpdateProcessingRuleTiersDto,
} from '../models/index';
import {
    IBalanceReminderDtoFromJSON,
    IBalanceReminderDtoToJSON,
    ICategoryServiceDtoFromJSON,
    ICategoryServiceDtoToJSON,
    ICategorySpendLimitDtoFromJSON,
    ICategorySpendLimitDtoToJSON,
    ICategorySummaryDtoFromJSON,
    ICategorySummaryDtoToJSON,
    ICopayGroupDtoFromJSON,
    ICopayGroupDtoToJSON,
    ICovTableDtoFromJSON,
    ICovTableDtoToJSON,
    ICoverageDtoFromJSON,
    ICoverageDtoToJSON,
    IDeductiblePreviewRequestDtoFromJSON,
    IDeductiblePreviewRequestDtoToJSON,
    IDeductibleTierDtoFromJSON,
    IDeductibleTierDtoToJSON,
    IDeductibleUpdateRequestDtoFromJSON,
    IDeductibleUpdateRequestDtoToJSON,
    IElectionAmountDtoFromJSON,
    IElectionAmountDtoToJSON,
    IEnrollmentMatrixDtoFromJSON,
    IEnrollmentMatrixDtoToJSON,
    IEnrollmentMatrixPatchDtoFromJSON,
    IEnrollmentMatrixPatchDtoToJSON,
    IEnumTypeDtoFromJSON,
    IEnumTypeDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IFundingLevelSwitchingDtoFromJSON,
    IFundingLevelSwitchingDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IHealthPlanBaseDtoFromJSON,
    IHealthPlanBaseDtoToJSON,
    IHealthPlanDtoFromJSON,
    IHealthPlanDtoToJSON,
    IHealthPlanTierStatsDtoFromJSON,
    IHealthPlanTierStatsDtoToJSON,
    IHealthPolicyDtoFromJSON,
    IHealthPolicyDtoToJSON,
    IIdNameDtoFromJSON,
    IIdNameDtoToJSON,
    IIrsLimitDtoFromJSON,
    IIrsLimitDtoToJSON,
    IIrsLimitLiteDtoFromJSON,
    IIrsLimitLiteDtoToJSON,
    IMpTableDtoFromJSON,
    IMpTableDtoToJSON,
    IOrganizationLockDtoFromJSON,
    IOrganizationLockDtoToJSON,
    IPageCopayGroupDtoFromJSON,
    IPageCopayGroupDtoToJSON,
    IPageEnrollmentMatrixDtoFromJSON,
    IPageEnrollmentMatrixDtoToJSON,
    IPageProcessingRuleDtoFromJSON,
    IPageProcessingRuleDtoToJSON,
    IPageServiceDtoFromJSON,
    IPageServiceDtoToJSON,
    IPageTriggerDtoFromJSON,
    IPageTriggerDtoToJSON,
    IPageableFromJSON,
    IPageableToJSON,
    IPayoutDefinitionCreateDtoFromJSON,
    IPayoutDefinitionCreateDtoToJSON,
    IPayoutDefinitionDtoFromJSON,
    IPayoutDefinitionDtoToJSON,
    IPayoutDefinitionPlanDtoFromJSON,
    IPayoutDefinitionPlanDtoToJSON,
    IPayoutDefinitionServiceDtoFromJSON,
    IPayoutDefinitionServiceDtoToJSON,
    IPayoutDefinitionUpdateDtoFromJSON,
    IPayoutDefinitionUpdateDtoToJSON,
    IPersonSpendLimitDtoFromJSON,
    IPersonSpendLimitDtoToJSON,
    IPlanCodeValidationRequestDtoFromJSON,
    IPlanCodeValidationRequestDtoToJSON,
    IPlanCodeValidationResponseDtoFromJSON,
    IPlanCodeValidationResponseDtoToJSON,
    IPlanDtoFromJSON,
    IPlanDtoToJSON,
    IPlanGracePeriodDtoFromJSON,
    IPlanGracePeriodDtoToJSON,
    IPlanIdsDtoFromJSON,
    IPlanIdsDtoToJSON,
    IPlanPrimaryConfigLiteDtoFromJSON,
    IPlanPrimaryConfigLiteDtoToJSON,
    IPlanReactivationDtoFromJSON,
    IPlanReactivationDtoToJSON,
    IPlanTemplateConfigDtoFromJSON,
    IPlanTemplateConfigDtoToJSON,
    IPlanTerminationPropertiesDtoFromJSON,
    IPlanTerminationPropertiesDtoToJSON,
    IPlanTerminationPropertiesPatchDtoFromJSON,
    IPlanTerminationPropertiesPatchDtoToJSON,
    IPlanYearDtoFromJSON,
    IPlanYearDtoToJSON,
    IPlanYearLiteDtoFromJSON,
    IPlanYearLiteDtoToJSON,
    IPlanYearPlanDtoFromJSON,
    IPlanYearPlanDtoToJSON,
    IPolicyElectionDtoFromJSON,
    IPolicyElectionDtoToJSON,
    IPolicyEligibleServicesDtoFromJSON,
    IPolicyEligibleServicesDtoToJSON,
    IPolicyEnrollmentDtoFromJSON,
    IPolicyEnrollmentDtoToJSON,
    IPolicyFundIdResponseDtoFromJSON,
    IPolicyFundIdResponseDtoToJSON,
    IPolicyLimitsDtoFromJSON,
    IPolicyLimitsDtoToJSON,
    IPolicySpendLimitsDtoFromJSON,
    IPolicySpendLimitsDtoToJSON,
    IPolicyStatusDtoFromJSON,
    IPolicyStatusDtoToJSON,
    IPriorPlanDtoFromJSON,
    IPriorPlanDtoToJSON,
    IProcessingRuleDtoFromJSON,
    IProcessingRuleDtoToJSON,
    IReducedPolicyDtoFromJSON,
    IReducedPolicyDtoToJSON,
    ISequenceDtoFromJSON,
    ISequenceDtoToJSON,
    IServiceConfigDtoFromJSON,
    IServiceConfigDtoToJSON,
    IServiceCreateDtoFromJSON,
    IServiceCreateDtoToJSON,
    IServiceDtoFromJSON,
    IServiceDtoToJSON,
    IServiceUpdateRequestFromJSON,
    IServiceUpdateRequestToJSON,
    ISpendLimitPeriodDtoFromJSON,
    ISpendLimitPeriodDtoToJSON,
    ISpendLimitPeriodRemainingDtoFromJSON,
    ISpendLimitPeriodRemainingDtoToJSON,
    ISpendLimitRemainingByAccountDtoFromJSON,
    ISpendLimitRemainingByAccountDtoToJSON,
    ITriggerDtoFromJSON,
    ITriggerDtoToJSON,
    IUpdatePayoutRuleTypeRequestDtoFromJSON,
    IUpdatePayoutRuleTypeRequestDtoToJSON,
    IUpdateProcessingRuleTiersDtoFromJSON,
    IUpdateProcessingRuleTiersDtoToJSON,
} from '../models/index';

export interface CheckIsTemplateAssignedRequest {
    templateId: number;
}

export interface CheckReactivationEligibilityRequest {
    planIds: Set<number>;
}

export interface CreateCopayGroupRequest {
    iCopayGroupDto: ICopayGroupDto;
}

export interface CreatePayoutDefinitionRequest {
    iPayoutDefinitionCreateDto: IPayoutDefinitionCreateDto;
}

export interface CreatePlanTerminationPropertiesRequest {
    iPlanTerminationPropertiesDto: IPlanTerminationPropertiesDto;
}

export interface CreateServiceRequest {
    iServiceCreateDto: IServiceCreateDto;
}

export interface CreateServiceConfigRequest {
    iServiceConfigDto: IServiceConfigDto;
}

export interface CreateTriggerRequest {
    iTriggerDto: ITriggerDto;
}

export interface DeductiblesUpdateRequest {
    employeeId: number;
    iDeductibleUpdateRequestDto: IDeductibleUpdateRequestDto;
}

export interface DeleteCopayGroupRequest {
    id: number;
}

export interface DeletePayoutDefinitionRequest {
    id: number;
}

export interface DeleteServiceConfigRequest {
    id: number;
}

export interface GetActivePlansByPlanYearIdRequest {
    id: number;
}

export interface GetAllCopayGroupsRequest {
    organizationId?: number;
    organizationPath?: string;
    copayStatus?: GetAllCopayGroupsCopayStatusEnum;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllHealthPlanTemplatesRequest {
    organizationId?: number;
    organizationPath?: string;
    planStatus?: GetAllHealthPlanTemplatesPlanStatusEnum;
    name?: string;
    id?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllHealthPlansRequest {
    organizationId: number;
    planStatus?: GetAllHealthPlansPlanStatusEnum;
    name?: string;
    id?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllIrsLimitsRequest {
    coverageLevel?: GetAllIrsLimitsCoverageLevelEnum;
    type?: GetAllIrsLimitsTypeEnum;
    frequencyType?: GetAllIrsLimitsFrequencyTypeEnum;
    taxYear?: Array<number>;
}

export interface GetAllPayoutDefinitionsRequest {
    organizationPath: string;
    name?: string;
    id?: number;
    isLimitedUse?: boolean;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllPlans1Request {
    organizationId: number;
    planStatus?: GetAllPlans1PlanStatusEnum;
    planStatuses?: Array<GetAllPlans1PlanStatusesEnum>;
    name?: string;
    id?: number;
    ids?: Set<number>;
    accountType?: GetAllPlans1AccountTypeEnum;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllSequencesRequest {
    organizationId?: number;
}

export interface GetByOrganizationIdRequest {
    organizationId: number;
}

export interface GetCategoryServicesRequest {
    categories?: Set<GetCategoryServicesCategoriesEnum>;
    serviceTypes?: Set<GetCategoryServicesServiceTypesEnum>;
    name?: string;
    sort?: Array<string>;
}

export interface GetCategorySpendLimitPeriodsRemainingRequest {
    accountId: number;
    periodFrom: Date;
}

export interface GetClosestEnrollmentMatrixesRequest {
    orgPath: string;
    enrollmentDate: string;
    templateId?: number;
    planYearId?: number;
}

export interface GetCopayGroupRequest {
    id: number;
}

export interface GetCoveragesRequest {
    organizationPath: string;
}

export interface GetDeductibleServicesRequest {
    employeeId: number;
    serviceName?: string;
    serviceType?: GetDeductibleServicesServiceTypeEnum;
    serviceOn?: Date;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetDeductiblesRequest {
    employeeId: number;
    dependentId?: number;
    serviceOn?: Date;
    healthPlanId?: number;
    deductibleType?: GetDeductiblesDeductibleTypeEnum;
}

export interface GetElectionAmountRequest {
    planId: number;
    effectiveDate: string;
}

export interface GetEligibleServicesRequest {
    planId: number;
    serviceTypes?: Set<GetEligibleServicesServiceTypesEnum>;
    name?: string;
    categories?: Set<GetEligibleServicesCategoriesEnum>;
}

export interface GetEligibleServicesByPoliciesRequest {
    policyIds: Set<number>;
    serviceTypes?: Set<GetEligibleServicesByPoliciesServiceTypesEnum>;
}

export interface GetEnrollmentMatrixesRequest {
    organizationPath: string;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetExpiredEnrollmentMatrixesRequest {
    organizationPath: string;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetHealthPlanRequest {
    id: number;
}

export interface GetHealthPlanNotesRequest {
    id: number;
}

export interface GetHealthPlanTierStatisticsRequest {
    planId: number;
    organizationPath: string;
}

export interface GetHealthPlanYearsByEmployeeRequest {
    employeeId: number;
}

export interface GetHealthPolicy1Request {
    employeeId: number;
    healthPlanId: number;
}

export interface GetIrsMaximumsRequest {
    coverageLevelType?: GetIrsMaximumsCoverageLevelTypeEnum;
}

export interface GetIsPlanLevelFundingEnabledRequest {
    organizationPath: string;
}

export interface GetLinkedSystemTemplatesRequest {
    organizationId: number;
    onlyLinked: boolean;
    name?: string;
}

export interface GetOrganizationLockStatusRequest {
    organizationId: number;
}

export interface GetPayoutDefinitionRequest {
    id: number;
}

export interface GetPayoutDefinitionsLiteRequest {
    organizationPath: string;
}

export interface GetPlan1Request {
    planId: number;
}

export interface GetPlanByAccountIdRequest {
    accountId: number;
}

export interface GetPlanIdsWithinPlanHierarchyRequest {
    templateId: number;
}

export interface GetPlanNotesRequest {
    id: number;
}

export interface GetPlanPrimaryConfigByAccountIdRequest {
    accountId: number;
}

export interface GetPlanTemplatesByPayoutDefinitionIdAndServiceIdRequest {
    id: number;
    serviceId?: number;
}

export interface GetPlanTerminationProperties1Request {
    planId: number;
}

export interface GetPlanWithGracePeriodRequest {
    planId: number;
    terminationDate: string;
}

export interface GetPlanYearRequest {
    id: number;
}

export interface GetPlansWithActiveGracePeriodRequest {
    organizationId: number;
    terminationDate: string;
    planStatuses?: Set<GetPlansWithActiveGracePeriodPlanStatusesEnum>;
}

export interface GetPoliciesByFilterRequest {
    planId?: number;
    employeeId?: number;
    accountId?: Set<number>;
}

export interface GetPolicyAccountsByFilterRequest {
    employeeId: number;
    validFrom: Date;
}

export interface GetPolicyElectionRequest {
    policyId: number;
    electionId: number;
}

export interface GetPolicyLimitsRequest {
    policyId: number;
    serviceOn: Date;
    dependentId?: number;
    serviceId?: number;
}

export interface GetPolicyStatusRequest {
    policyId: number;
    statusId: number;
}

export interface GetPolicyStatusesHistoryRequest {
    policyId: number;
}

export interface GetPriorPlanYearsRequest {
    organizationId: number;
    nextValidFrom: string;
}

export interface GetPriorPlansRequest {
    planYearId: number;
    accountType: GetPriorPlansAccountTypeEnum;
}

export interface GetProcessingRuleByIdRequest {
    id: number;
}

export interface GetProcessingRulesRequest {
    organizationPath: string;
    name?: string;
    isUsed?: boolean;
    id?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetReactivationEligiblePlansRequest {
    organizationId: number;
}

export interface GetReducedPoliciesRequest {
    accountIds: Set<number>;
}

export interface GetSequenceByIdRequest {
    id: number;
}

export interface GetServiceByIdRequest {
    id: number;
}

export interface GetServiceConfigsRequest {
    healthPlanId: number;
}

export interface GetServicesRequest {
    name?: string;
    serviceTypes?: Set<GetServicesServiceTypesEnum>;
    employeeId?: number;
    serviceOn?: string;
    ids?: Set<number>;
}

export interface GetServicesByFilterRequest {
    id: number;
    type?: GetServicesByFilterTypeEnum;
    categories?: Set<GetServicesByFilterCategoriesEnum>;
    planIds?: Array<number>;
}

export interface GetSpendLimitPeriodForAccountRequest {
    accountId: number;
}

export interface GetSpendLimitPeriodsRemainingRequest {
    accountId: number;
    periodFrom: string;
}

export interface GetSpendLimitRemainingByAccountRequest {
    accountIds: Set<number>;
    periodFrom: Date;
}

export interface GetTemplatesRequest {
    organizationId?: number;
    organizationPath?: string;
    planStatus?: GetTemplatesPlanStatusEnum;
    name?: string;
    id?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetTriggersRequest {
    organizationPath: string;
    type?: GetTriggersTypeEnum;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface HealthPolicyExistsForEmployeeOnAGivenDate1Request {
    employeeId: number;
    effectiveDate: Date;
    excludedHealthPlanId?: number;
}

export interface PatchEnrollmentMatrixRequest {
    id: number;
    iEnrollmentMatrixPatchDto: IEnrollmentMatrixPatchDto;
}

export interface PatchPlanTerminationProperties1Request {
    planId: number;
    iPlanTerminationPropertiesPatchDto: IPlanTerminationPropertiesPatchDto;
}

export interface PreviewDeductiblesUpdateRequest {
    employeeId: number;
    iDeductiblePreviewRequestDto: IDeductiblePreviewRequestDto;
}

export interface ReactivatePlansRequest {
    iPlanReactivationDto: IPlanReactivationDto;
}

export interface SearchPersonSpendLimitsRequest {
    accountId: number;
    periodFrom: string;
}

export interface SearchPlanTerminationProperties1Request {
    organizationId?: number;
    planStatuses?: Set<SearchPlanTerminationProperties1PlanStatusesEnum>;
}

export interface SearchPlanYearsListRequest {
    pageable: IPageable;
    organizationId?: number;
    nextValidFrom?: string;
}

export interface SearchPolicyLimitByEmployeePlan1Request {
    employeeId: number;
    taxYear: number;
    birthDate: Date;
    planId: number;
    contributionDate?: Date;
}

export interface SearchServicesRequest {
    categoryTypes?: Set<SearchServicesCategoryTypesEnum>;
    serviceTypes?: Set<SearchServicesServiceTypesEnum>;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface UpdateCopayGroupRequest {
    id: number;
    iCopayGroupDto: ICopayGroupDto;
}

export interface UpdateIsPlanLevelFundingByPlanIdsRequest {
    iPlanIdsDto: IPlanIdsDto;
}

export interface UpdatePayoutDefinitionRequest {
    id: number;
    iPayoutDefinitionUpdateDto: IPayoutDefinitionUpdateDto;
}

export interface UpdateProcessingRuleRequest {
    id: number;
    iProcessingRuleDto: IProcessingRuleDto;
}

export interface UpdateProcessingRuleTiersRequest {
    id: number;
    iUpdateProcessingRuleTiersDto: IUpdateProcessingRuleTiersDto;
}

export interface UpdateProcessingRulesPayoutRulesRequest {
    id: number;
    iUpdatePayoutRuleTypeRequestDto: IUpdatePayoutRuleTypeRequestDto;
}

export interface UpdateSequenceByIdRequest {
    id: number;
    iSequenceDto: ISequenceDto;
}

export interface UpdateServiceRequest {
    id: number;
    iServiceUpdateRequest: IServiceUpdateRequest;
}

export interface UpdateServiceConfigRequest {
    id: number;
    iServiceConfigDto: IServiceConfigDto;
}

export interface ValidatePlanCodesRequest {
    iPlanCodeValidationRequestDto: IPlanCodeValidationRequestDto;
}

export interface ValidatePolicyExistenceWithSameFundIdRequest {
    employeeId: number;
    fundId: string;
    validFrom: Date;
    planId?: number;
    validTo?: Date;
}

/**
 * PolicyAdminServiceServiceApi - interface
 * 
 * @export
 * @interface PolicyAdminServiceServiceApiInterface
 */
export interface PolicyAdminServiceServiceApiInterface {
    /**
     * 
     * @summary Check plan template usability
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    checkIsTemplateAssignedRaw(requestParameters: CheckIsTemplateAssignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Check plan template usability
     */
    checkIsTemplateAssigned(requestParameters: CheckIsTemplateAssignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Check reactivation eligibility for plans
     * @param {Set<number>} planIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    checkReactivationEligibilityRaw(requestParameters: CheckReactivationEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Check reactivation eligibility for plans
     */
    checkReactivationEligibility(requestParameters: CheckReactivationEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean>;

    /**
     * 
     * @summary Create new copay group
     * @param {ICopayGroupDto} iCopayGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createCopayGroupRaw(requestParameters: CreateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>>;

    /**
     * Create new copay group
     */
    createCopayGroup(requestParameters: CreateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto>;

    /**
     * 
     * @summary Create new payout definition
     * @param {IPayoutDefinitionCreateDto} iPayoutDefinitionCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createPayoutDefinitionRaw(requestParameters: CreatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>>;

    /**
     * Create new payout definition
     */
    createPayoutDefinition(requestParameters: CreatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto>;

    /**
     * 
     * @summary Create plan termination properties
     * @param {IPlanTerminationPropertiesDto} iPlanTerminationPropertiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createPlanTerminationPropertiesRaw(requestParameters: CreatePlanTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Create plan termination properties
     */
    createPlanTerminationProperties(requestParameters: CreatePlanTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Create a new service
     * @param {IServiceCreateDto} iServiceCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createServiceRaw(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>>;

    /**
     * Create a new service
     */
    createService(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto>;

    /**
     * 
     * @summary Create new service config
     * @param {IServiceConfigDto} iServiceConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createServiceConfigRaw(requestParameters: CreateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceConfigDto>>;

    /**
     * Create new service config
     */
    createServiceConfig(requestParameters: CreateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceConfigDto>;

    /**
     * 
     * @summary Create custom trigger
     * @param {ITriggerDto} iTriggerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    createTriggerRaw(requestParameters: CreateTriggerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITriggerDto>>;

    /**
     * Create custom trigger
     */
    createTrigger(requestParameters: CreateTriggerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITriggerDto>;

    /**
     * 
     * @summary Update deductibles
     * @param {number} employeeId 
     * @param {IDeductibleUpdateRequestDto} iDeductibleUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    deductiblesUpdateRaw(requestParameters: DeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update deductibles
     */
    deductiblesUpdate(requestParameters: DeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete copay group
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    deleteCopayGroupRaw(requestParameters: DeleteCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete copay group
     */
    deleteCopayGroup(requestParameters: DeleteCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete payout definition by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    deletePayoutDefinitionRaw(requestParameters: DeletePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete payout definition by id
     */
    deletePayoutDefinition(requestParameters: DeletePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete service config
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    deleteServiceConfigRaw(requestParameters: DeleteServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete service config
     */
    deleteServiceConfig(requestParameters: DeleteServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Active plans by plan year ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getActivePlansByPlanYearIdRaw(requestParameters: GetActivePlansByPlanYearIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearPlanDto>>;

    /**
     * Get Active plans by plan year ID
     */
    getActivePlansByPlanYearId(requestParameters: GetActivePlansByPlanYearIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearPlanDto>;

    /**
     * 
     * @summary Get all copay groups
     * @param {number} [organizationId] 
     * @param {string} [organizationPath] 
     * @param {'ACTIVE' | 'EXPIRED'} [copayStatus] 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllCopayGroupsRaw(requestParameters: GetAllCopayGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageCopayGroupDto>>;

    /**
     * Get all copay groups
     */
    getAllCopayGroups(requestParameters: GetAllCopayGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageCopayGroupDto>;

    /**
     * 
     * @summary Get heath plan templates by organization id and status
     * @param {number} [organizationId] 
     * @param {string} [organizationPath] 
     * @param {'DRAFT' | 'ACTIVE' | 'UNDER_UPDATE'} [planStatus] 
     * @param {string} [name] 
     * @param {number} [id] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllHealthPlanTemplatesRaw(requestParameters: GetAllHealthPlanTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanBaseDto>>>;

    /**
     * Get heath plan templates by organization id and status
     */
    getAllHealthPlanTemplates(requestParameters: GetAllHealthPlanTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanBaseDto>>;

    /**
     * 
     * @summary Get heath plans by organization id and status
     * @param {number} organizationId 
     * @param {'DRAFT' | 'ACTIVE' | 'UNDER_UPDATE'} [planStatus] 
     * @param {string} [name] 
     * @param {number} [id] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllHealthPlansRaw(requestParameters: GetAllHealthPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanBaseDto>>>;

    /**
     * Get heath plans by organization id and status
     */
    getAllHealthPlans(requestParameters: GetAllHealthPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanBaseDto>>;

    /**
     * 
     * @summary Get all IRS Limits
     * @param {'FAMILY' | 'INDIVIDUAL' | 'ROLLOVER'} [coverageLevel] 
     * @param {'HCFSA_MAX' | 'HSA_MAX' | 'DCAP_MAX' | 'TRANSIT_MAX' | 'PARKING_MAX' | 'HCFSA_EE_ER_MAX'} [type] 
     * @param {'MONTHLY' | 'ANNUALLY'} [frequencyType] 
     * @param {Array<number>} [taxYear] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllIrsLimitsRaw(requestParameters: GetAllIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIrsLimitDto>>>;

    /**
     * Get all IRS Limits
     */
    getAllIrsLimits(requestParameters: GetAllIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIrsLimitDto>>;

    /**
     * Get all payout definitions and corresponding category types for given organization path
     * @param {string} organizationPath 
     * @param {string} [name] 
     * @param {number} [id] 
     * @param {boolean} [isLimitedUse] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllPayoutDefinitionsRaw(requestParameters: GetAllPayoutDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get all payout definitions and corresponding category types for given organization path
     */
    getAllPayoutDefinitions(requestParameters: GetAllPayoutDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get all plans grouped by AccountType
     * @param {number} organizationId 
     * @param {'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'READY_FOR_SETUP' | 'DELETED' | 'PENDING_ACTIVE' | 'UNDER_UPDATE' | 'TERMINATION_IN_PROGRESS' | 'PENDING_TERMINATION' | 'TERMINATED' | 'PENDING_REACTIVATION'} [planStatus] Deprecated. Use plan_statuses.
     * @param {Array<'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'READY_FOR_SETUP' | 'DELETED' | 'PENDING_ACTIVE' | 'UNDER_UPDATE' | 'TERMINATION_IN_PROGRESS' | 'PENDING_TERMINATION' | 'TERMINATED' | 'PENDING_REACTIVATION'>} [planStatuses] 
     * @param {string} [name] 
     * @param {number} [id] 
     * @param {Set<number>} [ids] 
     * @param {'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'} [accountType] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllPlans1Raw(requestParameters: GetAllPlans1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get all plans grouped by AccountType
     */
    getAllPlans1(requestParameters: GetAllPlans1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get all sequences for organization
     * @param {number} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllSequencesRaw(requestParameters: GetAllSequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ISequenceDto>>>;

    /**
     * Get all sequences for organization
     */
    getAllSequences(requestParameters: GetAllSequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ISequenceDto>>;

    /**
     * 
     * @summary Gets all services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getAllServicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Gets all services
     */
    getAllServices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan years by organization id
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getByOrganizationIdRaw(requestParameters: GetByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>>;

    /**
     * Get plan years by organization id
     */
    getByOrganizationId(requestParameters: GetByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategorySummaryDto>>>;

    /**
     */
    getCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategorySummaryDto>>;

    /**
     * 
     * @summary Get all existing services grouped by categories
     * @param {Set<'ADOPTION' | 'DENTAL' | 'DEPENDENT_CARE' | 'MEDICAL' | 'PARKING' | 'PREMIUM' | 'PHARMACY' | 'TRANSIT' | 'VISION' | 'LIFE_STYLE' | 'WELLNESS' | 'TRAVEL' | 'PLAN_SPECIFIC'>} [categories] 
     * @param {Set<'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'>} [serviceTypes] 
     * @param {string} [name] 
     * @param {Array<string>} [sort] Default sorting is by name ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCategoryServicesRaw(requestParameters: GetCategoryServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategoryServiceDto>>>;

    /**
     * Get all existing services grouped by categories
     */
    getCategoryServices(requestParameters: GetCategoryServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategoryServiceDto>>;

    /**
     * 
     * @summary Get category spend limit periods remaining
     * @param {number} accountId 
     * @param {Date} periodFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCategorySpendLimitPeriodsRemainingRaw(requestParameters: GetCategorySpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategorySpendLimitDto>>>;

    /**
     * Get category spend limit periods remaining
     */
    getCategorySpendLimitPeriodsRemaining(requestParameters: GetCategorySpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategorySpendLimitDto>>;

    /**
     * 
     * @summary Get closest suiting enrollment matrix for given filter values
     * @param {string} orgPath 
     * @param {string} enrollmentDate 
     * @param {number} [templateId] 
     * @param {number} [planYearId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getClosestEnrollmentMatrixesRaw(requestParameters: GetClosestEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>>;

    /**
     * Get closest suiting enrollment matrix for given filter values
     */
    getClosestEnrollmentMatrixes(requestParameters: GetClosestEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto>;

    /**
     * 
     * @summary Get copay group by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCopayGroupRaw(requestParameters: GetCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>>;

    /**
     * Get copay group by id
     */
    getCopayGroup(requestParameters: GetCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto>;

    /**
     * 
     * @summary Get all COV tables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCovTablesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICovTableDto>>>;

    /**
     * Get all COV tables
     */
    getCovTables(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICovTableDto>>;

    /**
     * 
     * @summary Get coverages
     * @param {string} organizationPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getCoveragesRaw(requestParameters: GetCoveragesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICoverageDto>>>;

    /**
     * Get coverages
     */
    getCoverages(requestParameters: GetCoveragesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICoverageDto>>;

    /**
     * 
     * @summary Get deductible services for given account
     * @param {number} employeeId 
     * @param {string} [serviceName] 
     * @param {'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'} [serviceType] 
     * @param {Date} [serviceOn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getDeductibleServicesRaw(requestParameters: GetDeductibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageServiceDto>>;

    /**
     * Get deductible services for given account
     */
    getDeductibleServices(requestParameters: GetDeductibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageServiceDto>;

    /**
     * 
     * @summary Get tiers with deductibles for given account
     * @param {number} employeeId 
     * @param {number} [dependentId] 
     * @param {Date} [serviceOn] 
     * @param {number} [healthPlanId] 
     * @param {'INDIVIDUAL_DEDUCTIBLE_MET' | 'FAMILY_DEDUCTIBLE_MET'} [deductibleType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getDeductiblesRaw(requestParameters: GetDeductiblesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDeductibleTierDto>>;

    /**
     * Get tiers with deductibles for given account
     */
    getDeductibles(requestParameters: GetDeductiblesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDeductibleTierDto>;

    /**
     * 
     * @summary Checks election amount.
     * @param {number} planId 
     * @param {string} effectiveDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getElectionAmountRaw(requestParameters: GetElectionAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IElectionAmountDto>>;

    /**
     * Checks election amount.
     */
    getElectionAmount(requestParameters: GetElectionAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IElectionAmountDto>;

    /**
     * 
     * @summary Get all existing plan\'s services grouped by categories
     * @param {number} planId 
     * @param {Set<'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'>} [serviceTypes] 
     * @param {string} [name] 
     * @param {Set<'ADOPTION' | 'DENTAL' | 'DEPENDENT_CARE' | 'MEDICAL' | 'PARKING' | 'PREMIUM' | 'PHARMACY' | 'TRANSIT' | 'VISION' | 'LIFE_STYLE' | 'WELLNESS' | 'TRAVEL' | 'PLAN_SPECIFIC'>} [categories] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getEligibleServicesRaw(requestParameters: GetEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategoryServiceDto>>>;

    /**
     * Get all existing plan\'s services grouped by categories
     */
    getEligibleServices(requestParameters: GetEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategoryServiceDto>>;

    /**
     * 
     * @summary Get eligible services grouped by policy and category
     * @param {Set<number>} policyIds 
     * @param {Set<'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'>} [serviceTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getEligibleServicesByPoliciesRaw(requestParameters: GetEligibleServicesByPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEligibleServicesDto>>>;

    /**
     * Get eligible services grouped by policy and category
     */
    getEligibleServicesByPolicies(requestParameters: GetEligibleServicesByPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEligibleServicesDto>>;

    /**
     * 
     * @summary Get enrollment matrixes for given organization path
     * @param {string} organizationPath 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getEnrollmentMatrixesRaw(requestParameters: GetEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEnrollmentMatrixDto>>;

    /**
     * Get enrollment matrixes for given organization path
     */
    getEnrollmentMatrixes(requestParameters: GetEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEnrollmentMatrixDto>;

    /**
     * 
     * @summary Get expired enrollment matrixes for given organization path
     * @param {string} organizationPath 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getExpiredEnrollmentMatrixesRaw(requestParameters: GetExpiredEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEnrollmentMatrixDto>>;

    /**
     * Get expired enrollment matrixes for given organization path
     */
    getExpiredEnrollmentMatrixes(requestParameters: GetExpiredEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEnrollmentMatrixDto>;

    /**
     * 
     * @summary Get all existing frequency types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getFrequencyTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>>;

    /**
     * Get all existing frequency types
     */
    getFrequencyTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>>;

    /**
     * 
     * @summary Get heath plan details
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getHealthPlanRaw(requestParameters: GetHealthPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanDto>>>;

    /**
     * Get heath plan details
     */
    getHealthPlan(requestParameters: GetHealthPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanDto>>;

    /**
     * 
     * @summary Get health plan notes
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getHealthPlanNotesRaw(requestParameters: GetHealthPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get health plan notes
     */
    getHealthPlanNotes(requestParameters: GetHealthPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get deductible tier statistics (family counts) for Health Plans linked to a plan
     * @param {number} planId 
     * @param {string} organizationPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getHealthPlanTierStatisticsRaw(requestParameters: GetHealthPlanTierStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanTierStatsDto>>>;

    /**
     * Get deductible tier statistics (family counts) for Health Plans linked to a plan
     */
    getHealthPlanTierStatistics(requestParameters: GetHealthPlanTierStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanTierStatsDto>>;

    /**
     * 
     * @summary Get health plan years for employee
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getHealthPlanYearsByEmployeeRaw(requestParameters: GetHealthPlanYearsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearLiteDto>>>;

    /**
     * Get health plan years for employee
     */
    getHealthPlanYearsByEmployee(requestParameters: GetHealthPlanYearsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearLiteDto>>;

    /**
     * 
     * @summary Get health policy
     * @param {number} employeeId 
     * @param {number} healthPlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getHealthPolicy1Raw(requestParameters: GetHealthPolicy1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPolicyDto>>>;

    /**
     * Get health policy
     */
    getHealthPolicy1(requestParameters: GetHealthPolicy1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPolicyDto>>;

    /**
     * 
     * @summary Retrieves IrsLimitTypes by IrsCoverageLevelType without years
     * @param {'FAMILY' | 'INDIVIDUAL' | 'ROLLOVER'} [coverageLevelType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getIrsMaximumsRaw(requestParameters: GetIrsMaximumsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIrsLimitLiteDto>>>;

    /**
     * Retrieves IrsLimitTypes by IrsCoverageLevelType without years
     */
    getIrsMaximums(requestParameters: GetIrsMaximumsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIrsLimitLiteDto>>;

    /**
     * 
     * @summary Get is plan level funding enabled
     * @param {string} organizationPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getIsPlanLevelFundingEnabledRaw(requestParameters: GetIsPlanLevelFundingEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get is plan level funding enabled
     */
    getIsPlanLevelFundingEnabled(requestParameters: GetIsPlanLevelFundingEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get linked system templates
     * @param {number} organizationId 
     * @param {boolean} onlyLinked 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getLinkedSystemTemplatesRaw(requestParameters: GetLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get linked system templates
     */
    getLinkedSystemTemplates(requestParameters: GetLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get all MP tables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getMpTablesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IMpTableDto>>>;

    /**
     * Get all MP tables
     */
    getMpTables(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IMpTableDto>>;

    /**
     * 
     * @summary Get Organization lock status
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getOrganizationLockStatusRaw(requestParameters: GetOrganizationLockStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>>;

    /**
     * Get Organization lock status
     */
    getOrganizationLockStatus(requestParameters: GetOrganizationLockStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto | null | undefined >;

    /**
     * 
     * @summary Get payout definition details
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPayoutDefinitionRaw(requestParameters: GetPayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>>;

    /**
     * Get payout definition details
     */
    getPayoutDefinition(requestParameters: GetPayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto>;

    /**
     * Returns id and name of all payout definitions available from the current organization level and higher levels. Intended to populate the \"Copy settings from\" dropdown. No pagination.
     * @summary Get lightweight list of payout definitions for given organization path
     * @param {string} organizationPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPayoutDefinitionsLiteRaw(requestParameters: GetPayoutDefinitionsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIdNameDto>>>;

    /**
     * Returns id and name of all payout definitions available from the current organization level and higher levels. Intended to populate the \"Copy settings from\" dropdown. No pagination.
     * Get lightweight list of payout definitions for given organization path
     */
    getPayoutDefinitionsLite(requestParameters: GetPayoutDefinitionsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIdNameDto>>;

    /**
     * 
     * @summary Get all payout rule types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPayoutRuleTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>>;

    /**
     * Get all payout rule types
     */
    getPayoutRuleTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>>;

    /**
     * 
     * @summary Get existing plan by id
     * @param {number} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlan1Raw(requestParameters: GetPlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>>;

    /**
     * Get existing plan by id
     */
    getPlan1(requestParameters: GetPlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto>;

    /**
     * 
     * @summary Get existing plan by account id
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanByAccountIdRaw(requestParameters: GetPlanByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>>;

    /**
     * Get existing plan by account id
     */
    getPlanByAccountId(requestParameters: GetPlanByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto>;

    /**
     * 
     * @summary Get plan and template ids within hierarchy
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanIdsWithinPlanHierarchyRaw(requestParameters: GetPlanIdsWithinPlanHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get plan and template ids within hierarchy
     */
    getPlanIdsWithinPlanHierarchy(requestParameters: GetPlanIdsWithinPlanHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan notes
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanNotesRaw(requestParameters: GetPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get plan notes
     */
    getPlanNotes(requestParameters: GetPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get existing plan primary config by account id
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanPrimaryConfigByAccountIdRaw(requestParameters: GetPlanPrimaryConfigByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanPrimaryConfigLiteDto>>;

    /**
     * Get existing plan primary config by account id
     */
    getPlanPrimaryConfigByAccountId(requestParameters: GetPlanPrimaryConfigByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanPrimaryConfigLiteDto>;

    /**
     * 
     * @summary Get plan templates for payout definition
     * @param {number} id 
     * @param {number} [serviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanTemplatesByPayoutDefinitionIdAndServiceIdRaw(requestParameters: GetPlanTemplatesByPayoutDefinitionIdAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayoutDefinitionPlanDto>>>;

    /**
     * Get plan templates for payout definition
     */
    getPlanTemplatesByPayoutDefinitionIdAndServiceId(requestParameters: GetPlanTemplatesByPayoutDefinitionIdAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayoutDefinitionPlanDto>>;

    /**
     * 
     * @summary Get plan termination properties
     * @param {number} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanTerminationProperties1Raw(requestParameters: GetPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get plan termination properties
     */
    getPlanTerminationProperties1(requestParameters: GetPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan with grace period
     * @param {number} planId 
     * @param {string} terminationDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanWithGracePeriodRaw(requestParameters: GetPlanWithGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanGracePeriodDto>>;

    /**
     * Get plan with grace period
     */
    getPlanWithGracePeriod(requestParameters: GetPlanWithGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanGracePeriodDto>;

    /**
     * 
     * @summary Get plan year by its ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlanYearRaw(requestParameters: GetPlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>>;

    /**
     * Get plan year by its ID
     */
    getPlanYear(requestParameters: GetPlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto>;

    /**
     * 
     * @summary Get active plans and plans with an active grace period
     * @param {number} organizationId 
     * @param {string} terminationDate 
     * @param {Set<'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'READY_FOR_SETUP' | 'DELETED' | 'PENDING_ACTIVE' | 'UNDER_UPDATE' | 'TERMINATION_IN_PROGRESS' | 'PENDING_TERMINATION' | 'TERMINATED' | 'PENDING_REACTIVATION'>} [planStatuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPlansWithActiveGracePeriodRaw(requestParameters: GetPlansWithActiveGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanGracePeriodDto>>>;

    /**
     * Get active plans and plans with an active grace period
     */
    getPlansWithActiveGracePeriod(requestParameters: GetPlansWithActiveGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanGracePeriodDto>>;

    /**
     * 
     * @summary Get existing policy by plan id and employee id and account_id
     * @param {number} [planId] 
     * @param {number} [employeeId] 
     * @param {Set<number>} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPoliciesByFilterRaw(requestParameters: GetPoliciesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEnrollmentDto>>>;

    /**
     * Get existing policy by plan id and employee id and account_id
     */
    getPoliciesByFilter(requestParameters: GetPoliciesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEnrollmentDto>>;

    /**
     * 
     * @summary Get all accountIds by employee id and validFrom
     * @param {number} employeeId 
     * @param {Date} validFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPolicyAccountsByFilterRaw(requestParameters: GetPolicyAccountsByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>>;

    /**
     * Get all accountIds by employee id and validFrom
     */
    getPolicyAccountsByFilter(requestParameters: GetPolicyAccountsByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>>;

    /**
     * 
     * @summary Get existing policy election by id
     * @param {number} policyId 
     * @param {number} electionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPolicyElectionRaw(requestParameters: GetPolicyElectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyElectionDto>>;

    /**
     * Get existing policy election by id
     */
    getPolicyElection(requestParameters: GetPolicyElectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyElectionDto>;

    /**
     * 
     * @summary Get policy spend limits (commuter, person, category) for a given service date
     * @param {number} policyId 
     * @param {Date} serviceOn 
     * @param {number} [dependentId] 
     * @param {number} [serviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPolicyLimitsRaw(requestParameters: GetPolicyLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicySpendLimitsDto>>;

    /**
     * Get policy spend limits (commuter, person, category) for a given service date
     */
    getPolicyLimits(requestParameters: GetPolicyLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicySpendLimitsDto>;

    /**
     * 
     * @summary Get existing policy status by id
     * @param {number} policyId 
     * @param {number} statusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPolicyStatusRaw(requestParameters: GetPolicyStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyStatusDto>>;

    /**
     * Get existing policy status by id
     */
    getPolicyStatus(requestParameters: GetPolicyStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyStatusDto>;

    /**
     * 
     * @summary Get policy statuses history by policy id
     * @param {number} policyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPolicyStatusesHistoryRaw(requestParameters: GetPolicyStatusesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyStatusDto>>>;

    /**
     * Get policy statuses history by policy id
     */
    getPolicyStatusesHistory(requestParameters: GetPolicyStatusesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyStatusDto>>;

    /**
     * 
     * @summary Get prior plan years by organization id and next plan year valid from
     * @param {number} organizationId 
     * @param {string} nextValidFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPriorPlanYearsRaw(requestParameters: GetPriorPlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>>;

    /**
     * Get prior plan years by organization id and next plan year valid from
     */
    getPriorPlanYears(requestParameters: GetPriorPlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>>;

    /**
     * 
     * @summary Get prior plans by plan year id and account type
     * @param {number} planYearId 
     * @param {'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'} accountType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getPriorPlansRaw(requestParameters: GetPriorPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPriorPlanDto>>>;

    /**
     * Get prior plans by plan year id and account type
     */
    getPriorPlans(requestParameters: GetPriorPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPriorPlanDto>>;

    /**
     * 
     * @summary Find processing rule by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getProcessingRuleByIdRaw(requestParameters: GetProcessingRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>>;

    /**
     * Find processing rule by id
     */
    getProcessingRuleById(requestParameters: GetProcessingRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto>;

    /**
     * 
     * @summary Get processing rules for given organization path
     * @param {string} organizationPath 
     * @param {string} [name] 
     * @param {boolean} [isUsed] 
     * @param {number} [id] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getProcessingRulesRaw(requestParameters: GetProcessingRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageProcessingRuleDto>>;

    /**
     * Get processing rules for given organization path
     */
    getProcessingRules(requestParameters: GetProcessingRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageProcessingRuleDto>;

    /**
     * 
     * @summary Get all existing proof of expenses options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getProofOfExpensesOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>>;

    /**
     * Get all existing proof of expenses options
     */
    getProofOfExpensesOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>>;

    /**
     * 
     * @summary Get plans eligible for reactivation by organization id
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getReactivationEligiblePlansRaw(requestParameters: GetReactivationEligiblePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanDto>>>;

    /**
     * Get plans eligible for reactivation by organization id
     */
    getReactivationEligiblePlans(requestParameters: GetReactivationEligiblePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanDto>>;

    /**
     * 
     * @summary Retrieve reduced policies by account ids
     * @param {Set<number>} accountIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getReducedPoliciesRaw(requestParameters: GetReducedPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IReducedPolicyDto>>>;

    /**
     * Retrieve reduced policies by account ids
     */
    getReducedPolicies(requestParameters: GetReducedPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IReducedPolicyDto>>;

    /**
     * 
     * @summary Get all sequences for organization
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getSequenceByIdRaw(requestParameters: GetSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>>;

    /**
     * Get all sequences for organization
     */
    getSequenceById(requestParameters: GetSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto>;

    /**
     * 
     * @summary Get service by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getServiceByIdRaw(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>>;

    /**
     * Get service by id
     */
    getServiceById(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto>;

    /**
     * 
     * @summary Get all existing service category types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getServiceCategoryTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>>;

    /**
     * Get all existing service category types
     */
    getServiceCategoryTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>>;

    /**
     * 
     * @summary Get list of service configs for given health plan
     * @param {number} healthPlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getServiceConfigsRaw(requestParameters: GetServiceConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceConfigDto>>>;

    /**
     * Get list of service configs for given health plan
     */
    getServiceConfigs(requestParameters: GetServiceConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceConfigDto>>;

    /**
     * 
     * @summary Get services by name and employee_id
     * @param {string} [name] 
     * @param {Set<'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'>} [serviceTypes] 
     * @param {number} [employeeId] 
     * @param {string} [serviceOn] 
     * @param {Set<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getServicesRaw(requestParameters: GetServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceDto>>>;

    /**
     * Get services by name and employee_id
     */
    getServices(requestParameters: GetServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceDto>>;

    /**
     * 
     * @summary Get services for payout definition
     * @param {number} id 
     * @param {'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'} [type] 
     * @param {Set<'ADOPTION' | 'DENTAL' | 'DEPENDENT_CARE' | 'MEDICAL' | 'PARKING' | 'PREMIUM' | 'PHARMACY' | 'TRANSIT' | 'VISION' | 'LIFE_STYLE' | 'WELLNESS' | 'TRAVEL' | 'PLAN_SPECIFIC'>} [categories] 
     * @param {Array<number>} [planIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getServicesByFilterRaw(requestParameters: GetServicesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayoutDefinitionServiceDto>>>;

    /**
     * Get services for payout definition
     */
    getServicesByFilter(requestParameters: GetServicesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayoutDefinitionServiceDto>>;

    /**
     * 
     * @summary Get spend limit periods for account_id
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getSpendLimitPeriodForAccountRaw(requestParameters: GetSpendLimitPeriodForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitPeriodDto>>;

    /**
     * Get spend limit periods for account_id
     */
    getSpendLimitPeriodForAccount(requestParameters: GetSpendLimitPeriodForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitPeriodDto>;

    /**
     * 
     * @summary Get spend limit periods remaining
     * @param {number} accountId 
     * @param {string} periodFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getSpendLimitPeriodsRemainingRaw(requestParameters: GetSpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitPeriodRemainingDto>>;

    /**
     * Get spend limit periods remaining
     */
    getSpendLimitPeriodsRemaining(requestParameters: GetSpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitPeriodRemainingDto>;

    /**
     * 
     * @summary Get spend limit remaining by account(s)
     * @param {Set<number>} accountIds 
     * @param {Date} periodFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getSpendLimitRemainingByAccountRaw(requestParameters: GetSpendLimitRemainingByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitRemainingByAccountDto>>;

    /**
     * Get spend limit remaining by account(s)
     */
    getSpendLimitRemainingByAccount(requestParameters: GetSpendLimitRemainingByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitRemainingByAccountDto>;

    /**
     * 
     * @summary Get templates
     * @param {number} [organizationId] 
     * @param {string} [organizationPath] 
     * @param {'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'READY_FOR_SETUP' | 'DELETED' | 'PENDING_ACTIVE' | 'UNDER_UPDATE' | 'TERMINATION_IN_PROGRESS' | 'PENDING_TERMINATION' | 'TERMINATED' | 'PENDING_REACTIVATION'} [planStatus] 
     * @param {string} [name] 
     * @param {number} [id] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getTemplatesRaw(requestParameters: GetTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanTemplateConfigDto>>;

    /**
     * Get templates
     */
    getTemplates(requestParameters: GetTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanTemplateConfigDto>;

    /**
     * 
     * @summary Get all existing triggers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getTriggerTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>>;

    /**
     * Get all existing triggers
     */
    getTriggerTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>>;

    /**
     * 
     * @summary Get triggers by organization path and optional trigger category type
     * @param {string} organizationPath 
     * @param {'EXTERNAL' | 'FAMILY' | 'EMBEDDED'} [type] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    getTriggersRaw(requestParameters: GetTriggersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageTriggerDto>>;

    /**
     * Get triggers by organization path and optional trigger category type
     */
    getTriggers(requestParameters: GetTriggersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageTriggerDto>;

    /**
     * 
     * @summary Check if the employee has any active health policy on the given effective date
     * @param {number} employeeId 
     * @param {Date} effectiveDate 
     * @param {number} [excludedHealthPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    healthPolicyExistsForEmployeeOnAGivenDate1Raw(requestParameters: HealthPolicyExistsForEmployeeOnAGivenDate1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Check if the employee has any active health policy on the given effective date
     */
    healthPolicyExistsForEmployeeOnAGivenDate1(requestParameters: HealthPolicyExistsForEmployeeOnAGivenDate1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean>;

    /**
     * 
     * @summary Patch enrollment matrix by id
     * @param {number} id 
     * @param {IEnrollmentMatrixPatchDto} iEnrollmentMatrixPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    patchEnrollmentMatrixRaw(requestParameters: PatchEnrollmentMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>>;

    /**
     * Patch enrollment matrix by id
     */
    patchEnrollmentMatrix(requestParameters: PatchEnrollmentMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto>;

    /**
     * 
     * @summary Update plan termination properties
     * @param {number} planId 
     * @param {IPlanTerminationPropertiesPatchDto} iPlanTerminationPropertiesPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    patchPlanTerminationProperties1Raw(requestParameters: PatchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update plan termination properties
     */
    patchPlanTerminationProperties1(requestParameters: PatchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Preview deductible update
     * @param {number} employeeId 
     * @param {IDeductiblePreviewRequestDto} iDeductiblePreviewRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    previewDeductiblesUpdateRaw(requestParameters: PreviewDeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Preview deductible update
     */
    previewDeductiblesUpdate(requestParameters: PreviewDeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Reactivate terminated or termination-in-progress plans
     * @param {IPlanReactivationDto} iPlanReactivationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    reactivatePlansRaw(requestParameters: ReactivatePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reactivate terminated or termination-in-progress plans
     */
    reactivatePlans(requestParameters: ReactivatePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Search person spend limits for Employee (including all his dependents) by account id and period
     * @param {number} accountId 
     * @param {string} periodFrom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchPersonSpendLimitsRaw(requestParameters: SearchPersonSpendLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPersonSpendLimitDto>>>;

    /**
     * Search person spend limits for Employee (including all his dependents) by account id and period
     */
    searchPersonSpendLimits(requestParameters: SearchPersonSpendLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPersonSpendLimitDto>>;

    /**
     * 
     * @summary Search plan termination properties
     * @param {number} [organizationId] 
     * @param {Set<'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'READY_FOR_SETUP' | 'DELETED' | 'PENDING_ACTIVE' | 'UNDER_UPDATE' | 'TERMINATION_IN_PROGRESS' | 'PENDING_TERMINATION' | 'TERMINATED' | 'PENDING_REACTIVATION'>} [planStatuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchPlanTerminationProperties1Raw(requestParameters: SearchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Search plan termination properties
     */
    searchPlanTerminationProperties1(requestParameters: SearchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan years by request params
     * @param {IPageable} pageable 
     * @param {number} [organizationId] 
     * @param {string} [nextValidFrom] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchPlanYearsListRaw(requestParameters: SearchPlanYearsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>>;

    /**
     * Get plan years by request params
     */
    searchPlanYearsList(requestParameters: SearchPlanYearsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>>;

    /**
     * 
     * @summary Search policies for balance reminder banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchPoliciesBalanceReminderRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceReminderDto>>;

    /**
     * Search policies for balance reminder banner
     */
    searchPoliciesBalanceReminder(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceReminderDto>;

    /**
     * 
     * @summary Retrieves IrsLimit by employee plan
     * @param {number} employeeId 
     * @param {number} taxYear 
     * @param {Date} birthDate 
     * @param {number} planId 
     * @param {Date} [contributionDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchPolicyLimitByEmployeePlan1Raw(requestParameters: SearchPolicyLimitByEmployeePlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyLimitsDto>>;

    /**
     * Retrieves IrsLimit by employee plan
     */
    searchPolicyLimitByEmployeePlan1(requestParameters: SearchPolicyLimitByEmployeePlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyLimitsDto>;

    /**
     * Returns paginated services filtered by category types, service types and name.
     * @summary Search services with pagination and filtering
     * @param {Set<'ADOPTION' | 'DENTAL' | 'DEPENDENT_CARE' | 'MEDICAL' | 'PARKING' | 'PREMIUM' | 'PHARMACY' | 'TRANSIT' | 'VISION' | 'LIFE_STYLE' | 'WELLNESS' | 'TRAVEL' | 'PLAN_SPECIFIC'>} [categoryTypes] 
     * @param {Set<'CARD' | 'MANUAL_CLAIM' | 'HEALTH_PLAN' | 'HIDDEN'>} [serviceTypes] 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    searchServicesRaw(requestParameters: SearchServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceDto>>>;

    /**
     * Returns paginated services filtered by category types, service types and name.
     * Search services with pagination and filtering
     */
    searchServices(requestParameters: SearchServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceDto>>;

    /**
     * 
     * @summary Update copay group
     * @param {number} id 
     * @param {ICopayGroupDto} iCopayGroupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateCopayGroupRaw(requestParameters: UpdateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>>;

    /**
     * Update copay group
     */
    updateCopayGroup(requestParameters: UpdateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto>;

    /**
     * 
     * @summary Update Plan Account Funding Configs
     * @param {IPlanIdsDto} iPlanIdsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateIsPlanLevelFundingByPlanIdsRaw(requestParameters: UpdateIsPlanLevelFundingByPlanIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IFundingLevelSwitchingDto>>>;

    /**
     * Update Plan Account Funding Configs
     */
    updateIsPlanLevelFundingByPlanIds(requestParameters: UpdateIsPlanLevelFundingByPlanIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IFundingLevelSwitchingDto>>;

    /**
     * 
     * @summary Update payout definition
     * @param {number} id 
     * @param {IPayoutDefinitionUpdateDto} iPayoutDefinitionUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updatePayoutDefinitionRaw(requestParameters: UpdatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>>;

    /**
     * Update payout definition
     */
    updatePayoutDefinition(requestParameters: UpdatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto>;

    /**
     * 
     * @summary Update processing rule
     * @param {number} id 
     * @param {IProcessingRuleDto} iProcessingRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateProcessingRuleRaw(requestParameters: UpdateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>>;

    /**
     * Update processing rule
     */
    updateProcessingRule(requestParameters: UpdateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto>;

    /**
     * 
     * @summary Bulk update of processing rule\'s tiers: payout rule type and Lock Card Purse configuration
     * @param {number} id 
     * @param {IUpdateProcessingRuleTiersDto} iUpdateProcessingRuleTiersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateProcessingRuleTiersRaw(requestParameters: UpdateProcessingRuleTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Bulk update of processing rule\'s tiers: payout rule type and Lock Card Purse configuration
     */
    updateProcessingRuleTiers(requestParameters: UpdateProcessingRuleTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update processing rule\'s tiers payout rules. Deprecated: use PATCH /processing-rules/{id}
     * @param {number} id 
     * @param {IUpdatePayoutRuleTypeRequestDto} iUpdatePayoutRuleTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateProcessingRulesPayoutRulesRaw(requestParameters: UpdateProcessingRulesPayoutRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update processing rule\'s tiers payout rules. Deprecated: use PATCH /processing-rules/{id}
     * @deprecated
     */
    updateProcessingRulesPayoutRules(requestParameters: UpdateProcessingRulesPayoutRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update sequence
     * @param {number} id 
     * @param {ISequenceDto} iSequenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateSequenceByIdRaw(requestParameters: UpdateSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>>;

    /**
     * Update sequence
     */
    updateSequenceById(requestParameters: UpdateSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto>;

    /**
     * 
     * @summary Update an existing service
     * @param {number} id 
     * @param {IServiceUpdateRequest} iServiceUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateServiceRaw(requestParameters: UpdateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>>;

    /**
     * Update an existing service
     */
    updateService(requestParameters: UpdateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto>;

    /**
     * 
     * @summary Update service config
     * @param {number} id 
     * @param {IServiceConfigDto} iServiceConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    updateServiceConfigRaw(requestParameters: UpdateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceConfigDto>>;

    /**
     * Update service config
     */
    updateServiceConfig(requestParameters: UpdateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceConfigDto>;

    /**
     * 
     * @summary Validate plan codes availability within organization
     * @param {IPlanCodeValidationRequestDto} iPlanCodeValidationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    validatePlanCodesRaw(requestParameters: ValidatePlanCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanCodeValidationResponseDto>>>;

    /**
     * Validate plan codes availability within organization
     */
    validatePlanCodes(requestParameters: ValidatePlanCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanCodeValidationResponseDto>>;

    /**
     * 
     * @summary Validate policy existence with the same fund id
     * @param {number} employeeId 
     * @param {string} fundId 
     * @param {Date} validFrom 
     * @param {number} [planId] 
     * @param {Date} [validTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAdminServiceServiceApiInterface
     */
    validatePolicyExistenceWithSameFundIdRaw(requestParameters: ValidatePolicyExistenceWithSameFundIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyFundIdResponseDto>>;

    /**
     * Validate policy existence with the same fund id
     */
    validatePolicyExistenceWithSameFundId(requestParameters: ValidatePolicyExistenceWithSameFundIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyFundIdResponseDto>;

}

/**
 * 
 */
export class PolicyAdminServiceServiceApi extends runtime.BaseAPI implements PolicyAdminServiceServiceApiInterface {

    /**
     * Check plan template usability
     */
    async checkIsTemplateAssignedRaw(requestParameters: CheckIsTemplateAssignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling checkIsTemplateAssigned().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['templateId'] != null) {
            queryParameters['template_id'] = requestParameters['templateId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/template-assigned`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Check plan template usability
     */
    async checkIsTemplateAssigned(requestParameters: CheckIsTemplateAssignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.checkIsTemplateAssignedRaw(requestParameters, initOverrides);
    }

    /**
     * Check reactivation eligibility for plans
     */
    async checkReactivationEligibilityRaw(requestParameters: CheckReactivationEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['planIds'] == null) {
            throw new runtime.RequiredError(
                'planIds',
                'Required parameter "planIds" was null or undefined when calling checkReactivationEligibility().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/reactivation-eligibility`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check reactivation eligibility for plans
     */
    async checkReactivationEligibility(requestParameters: CheckReactivationEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkReactivationEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new copay group
     */
    async createCopayGroupRaw(requestParameters: CreateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>> {
        if (requestParameters['iCopayGroupDto'] == null) {
            throw new runtime.RequiredError(
                'iCopayGroupDto',
                'Required parameter "iCopayGroupDto" was null or undefined when calling createCopayGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/copay-groups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICopayGroupDtoToJSON(requestParameters['iCopayGroupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICopayGroupDtoFromJSON(jsonValue));
    }

    /**
     * Create new copay group
     */
    async createCopayGroup(requestParameters: CreateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto> {
        const response = await this.createCopayGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new payout definition
     */
    async createPayoutDefinitionRaw(requestParameters: CreatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>> {
        if (requestParameters['iPayoutDefinitionCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iPayoutDefinitionCreateDto',
                'Required parameter "iPayoutDefinitionCreateDto" was null or undefined when calling createPayoutDefinition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPayoutDefinitionCreateDtoToJSON(requestParameters['iPayoutDefinitionCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayoutDefinitionDtoFromJSON(jsonValue));
    }

    /**
     * Create new payout definition
     */
    async createPayoutDefinition(requestParameters: CreatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto> {
        const response = await this.createPayoutDefinitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create plan termination properties
     */
    async createPlanTerminationPropertiesRaw(requestParameters: CreatePlanTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iPlanTerminationPropertiesDto'] == null) {
            throw new runtime.RequiredError(
                'iPlanTerminationPropertiesDto',
                'Required parameter "iPlanTerminationPropertiesDto" was null or undefined when calling createPlanTerminationProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/termination-properties`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanTerminationPropertiesDtoToJSON(requestParameters['iPlanTerminationPropertiesDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create plan termination properties
     */
    async createPlanTerminationProperties(requestParameters: CreatePlanTerminationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPlanTerminationPropertiesRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new service
     */
    async createServiceRaw(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>> {
        if (requestParameters['iServiceCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iServiceCreateDto',
                'Required parameter "iServiceCreateDto" was null or undefined when calling createService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IServiceCreateDtoToJSON(requestParameters['iServiceCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IServiceDtoFromJSON(jsonValue));
    }

    /**
     * Create a new service
     */
    async createService(requestParameters: CreateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto> {
        const response = await this.createServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new service config
     */
    async createServiceConfigRaw(requestParameters: CreateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceConfigDto>> {
        if (requestParameters['iServiceConfigDto'] == null) {
            throw new runtime.RequiredError(
                'iServiceConfigDto',
                'Required parameter "iServiceConfigDto" was null or undefined when calling createServiceConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/service-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IServiceConfigDtoToJSON(requestParameters['iServiceConfigDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IServiceConfigDtoFromJSON(jsonValue));
    }

    /**
     * Create new service config
     */
    async createServiceConfig(requestParameters: CreateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceConfigDto> {
        const response = await this.createServiceConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create custom trigger
     */
    async createTriggerRaw(requestParameters: CreateTriggerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITriggerDto>> {
        if (requestParameters['iTriggerDto'] == null) {
            throw new runtime.RequiredError(
                'iTriggerDto',
                'Required parameter "iTriggerDto" was null or undefined when calling createTrigger().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/triggers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITriggerDtoToJSON(requestParameters['iTriggerDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITriggerDtoFromJSON(jsonValue));
    }

    /**
     * Create custom trigger
     */
    async createTrigger(requestParameters: CreateTriggerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITriggerDto> {
        const response = await this.createTriggerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update deductibles
     */
    async deductiblesUpdateRaw(requestParameters: DeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling deductiblesUpdate().'
            );
        }

        if (requestParameters['iDeductibleUpdateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iDeductibleUpdateRequestDto',
                'Required parameter "iDeductibleUpdateRequestDto" was null or undefined when calling deductiblesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/deductibles/employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IDeductibleUpdateRequestDtoToJSON(requestParameters['iDeductibleUpdateRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update deductibles
     */
    async deductiblesUpdate(requestParameters: DeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deductiblesUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Delete copay group
     */
    async deleteCopayGroupRaw(requestParameters: DeleteCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCopayGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/copay-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete copay group
     */
    async deleteCopayGroup(requestParameters: DeleteCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCopayGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Delete payout definition by id
     */
    async deletePayoutDefinitionRaw(requestParameters: DeletePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePayoutDefinition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete payout definition by id
     */
    async deletePayoutDefinition(requestParameters: DeletePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePayoutDefinitionRaw(requestParameters, initOverrides);
    }

    /**
     * Delete service config
     */
    async deleteServiceConfigRaw(requestParameters: DeleteServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteServiceConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/service-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete service config
     */
    async deleteServiceConfig(requestParameters: DeleteServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceConfigRaw(requestParameters, initOverrides);
    }

    /**
     * Get Active plans by plan year ID
     */
    async getActivePlansByPlanYearIdRaw(requestParameters: GetActivePlansByPlanYearIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearPlanDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getActivePlansByPlanYearId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/{id}/plans`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanYearPlanDtoFromJSON(jsonValue));
    }

    /**
     * Get Active plans by plan year ID
     */
    async getActivePlansByPlanYearId(requestParameters: GetActivePlansByPlanYearIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearPlanDto> {
        const response = await this.getActivePlansByPlanYearIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all copay groups
     */
    async getAllCopayGroupsRaw(requestParameters: GetAllCopayGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageCopayGroupDto>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['copayStatus'] != null) {
            queryParameters['copay_status'] = requestParameters['copayStatus'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/copay-groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageCopayGroupDtoFromJSON(jsonValue));
    }

    /**
     * Get all copay groups
     */
    async getAllCopayGroups(requestParameters: GetAllCopayGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageCopayGroupDto> {
        const response = await this.getAllCopayGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get heath plan templates by organization id and status
     */
    async getAllHealthPlanTemplatesRaw(requestParameters: GetAllHealthPlanTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanBaseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['planStatus'] != null) {
            queryParameters['plan_status'] = requestParameters['planStatus'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHealthPlanBaseDtoFromJSON));
    }

    /**
     * Get heath plan templates by organization id and status
     */
    async getAllHealthPlanTemplates(requestParameters: GetAllHealthPlanTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanBaseDto>> {
        const response = await this.getAllHealthPlanTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get heath plans by organization id and status
     */
    async getAllHealthPlansRaw(requestParameters: GetAllHealthPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanBaseDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getAllHealthPlans().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['planStatus'] != null) {
            queryParameters['plan_status'] = requestParameters['planStatus'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHealthPlanBaseDtoFromJSON));
    }

    /**
     * Get heath plans by organization id and status
     */
    async getAllHealthPlans(requestParameters: GetAllHealthPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanBaseDto>> {
        const response = await this.getAllHealthPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all IRS Limits
     */
    async getAllIrsLimitsRaw(requestParameters: GetAllIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIrsLimitDto>>> {
        const queryParameters: any = {};

        if (requestParameters['coverageLevel'] != null) {
            queryParameters['coverage_level'] = requestParameters['coverageLevel'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['frequencyType'] != null) {
            queryParameters['frequency_type'] = requestParameters['frequencyType'];
        }

        if (requestParameters['taxYear'] != null) {
            queryParameters['tax_year'] = requestParameters['taxYear'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/irs-maximums`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IIrsLimitDtoFromJSON));
    }

    /**
     * Get all IRS Limits
     */
    async getAllIrsLimits(requestParameters: GetAllIrsLimitsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIrsLimitDto>> {
        const response = await this.getAllIrsLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all payout definitions and corresponding category types for given organization path
     */
    async getAllPayoutDefinitionsRaw(requestParameters: GetAllPayoutDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getAllPayoutDefinitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['isLimitedUse'] != null) {
            queryParameters['is_limited_use'] = requestParameters['isLimitedUse'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all payout definitions and corresponding category types for given organization path
     */
    async getAllPayoutDefinitions(requestParameters: GetAllPayoutDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllPayoutDefinitionsRaw(requestParameters, initOverrides);
    }

    /**
     * Get all plans grouped by AccountType
     */
    async getAllPlans1Raw(requestParameters: GetAllPlans1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getAllPlans1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['planStatus'] != null) {
            queryParameters['plan_status'] = requestParameters['planStatus'];
        }

        if (requestParameters['planStatuses'] != null) {
            queryParameters['plan_statuses'] = requestParameters['planStatuses'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['accountType'] != null) {
            queryParameters['account_type'] = requestParameters['accountType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get all plans grouped by AccountType
     */
    async getAllPlans1(requestParameters: GetAllPlans1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAllPlans1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all sequences for organization
     */
    async getAllSequencesRaw(requestParameters: GetAllSequencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ISequenceDto>>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sequences`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ISequenceDtoFromJSON));
    }

    /**
     * Get all sequences for organization
     */
    async getAllSequences(requestParameters: GetAllSequencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ISequenceDto>> {
        const response = await this.getAllSequencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all services
     */
    async getAllServicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Gets all services
     */
    async getAllServices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllServicesRaw(initOverrides);
    }

    /**
     * Get plan years by organization id
     */
    async getByOrganizationIdRaw(requestParameters: GetByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getByOrganizationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanYearDtoFromJSON));
    }

    /**
     * Get plan years by organization id
     */
    async getByOrganizationId(requestParameters: GetByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>> {
        const response = await this.getByOrganizationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategorySummaryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICategorySummaryDtoFromJSON));
    }

    /**
     */
    async getCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategorySummaryDto>> {
        const response = await this.getCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing services grouped by categories
     */
    async getCategoryServicesRaw(requestParameters: GetCategoryServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategoryServiceDto>>> {
        const queryParameters: any = {};

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        if (requestParameters['serviceTypes'] != null) {
            queryParameters['service_types'] = requestParameters['serviceTypes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/categories/services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICategoryServiceDtoFromJSON));
    }

    /**
     * Get all existing services grouped by categories
     */
    async getCategoryServices(requestParameters: GetCategoryServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategoryServiceDto>> {
        const response = await this.getCategoryServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get category spend limit periods remaining
     */
    async getCategorySpendLimitPeriodsRemainingRaw(requestParameters: GetCategorySpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategorySpendLimitDto>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getCategorySpendLimitPeriodsRemaining().'
            );
        }

        if (requestParameters['periodFrom'] == null) {
            throw new runtime.RequiredError(
                'periodFrom',
                'Required parameter "periodFrom" was null or undefined when calling getCategorySpendLimitPeriodsRemaining().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = (requestParameters['periodFrom'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/category-spend-limits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICategorySpendLimitDtoFromJSON));
    }

    /**
     * Get category spend limit periods remaining
     */
    async getCategorySpendLimitPeriodsRemaining(requestParameters: GetCategorySpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategorySpendLimitDto>> {
        const response = await this.getCategorySpendLimitPeriodsRemainingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get closest suiting enrollment matrix for given filter values
     */
    async getClosestEnrollmentMatrixesRaw(requestParameters: GetClosestEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>> {
        if (requestParameters['orgPath'] == null) {
            throw new runtime.RequiredError(
                'orgPath',
                'Required parameter "orgPath" was null or undefined when calling getClosestEnrollmentMatrixes().'
            );
        }

        if (requestParameters['enrollmentDate'] == null) {
            throw new runtime.RequiredError(
                'enrollmentDate',
                'Required parameter "enrollmentDate" was null or undefined when calling getClosestEnrollmentMatrixes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orgPath'] != null) {
            queryParameters['org_path'] = requestParameters['orgPath'];
        }

        if (requestParameters['enrollmentDate'] != null) {
            queryParameters['enrollment_date'] = requestParameters['enrollmentDate'];
        }

        if (requestParameters['templateId'] != null) {
            queryParameters['template_id'] = requestParameters['templateId'];
        }

        if (requestParameters['planYearId'] != null) {
            queryParameters['plan_year_id'] = requestParameters['planYearId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollment-matrixes/closest`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEnrollmentMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Get closest suiting enrollment matrix for given filter values
     */
    async getClosestEnrollmentMatrixes(requestParameters: GetClosestEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto> {
        const response = await this.getClosestEnrollmentMatrixesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get copay group by id
     */
    async getCopayGroupRaw(requestParameters: GetCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCopayGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/copay-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICopayGroupDtoFromJSON(jsonValue));
    }

    /**
     * Get copay group by id
     */
    async getCopayGroup(requestParameters: GetCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto> {
        const response = await this.getCopayGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all COV tables
     */
    async getCovTablesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICovTableDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cov-tables`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICovTableDtoFromJSON));
    }

    /**
     * Get all COV tables
     */
    async getCovTables(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICovTableDto>> {
        const response = await this.getCovTablesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get coverages
     */
    async getCoveragesRaw(requestParameters: GetCoveragesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICoverageDto>>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getCoverages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/coverages`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICoverageDtoFromJSON));
    }

    /**
     * Get coverages
     */
    async getCoverages(requestParameters: GetCoveragesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICoverageDto>> {
        const response = await this.getCoveragesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get deductible services for given account
     */
    async getDeductibleServicesRaw(requestParameters: GetDeductibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageServiceDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDeductibleServices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['serviceName'] != null) {
            queryParameters['service_name'] = requestParameters['serviceName'];
        }

        if (requestParameters['serviceType'] != null) {
            queryParameters['service_type'] = requestParameters['serviceType'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = (requestParameters['serviceOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/deductibles-services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageServiceDtoFromJSON(jsonValue));
    }

    /**
     * Get deductible services for given account
     */
    async getDeductibleServices(requestParameters: GetDeductibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageServiceDto> {
        const response = await this.getDeductibleServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tiers with deductibles for given account
     */
    async getDeductiblesRaw(requestParameters: GetDeductiblesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDeductibleTierDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDeductibles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = (requestParameters['serviceOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['healthPlanId'] != null) {
            queryParameters['health_plan_id'] = requestParameters['healthPlanId'];
        }

        if (requestParameters['deductibleType'] != null) {
            queryParameters['deductible_type'] = requestParameters['deductibleType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tiers/deductibles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDeductibleTierDtoFromJSON(jsonValue));
    }

    /**
     * Get tiers with deductibles for given account
     */
    async getDeductibles(requestParameters: GetDeductiblesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDeductibleTierDto> {
        const response = await this.getDeductiblesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks election amount.
     */
    async getElectionAmountRaw(requestParameters: GetElectionAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IElectionAmountDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getElectionAmount().'
            );
        }

        if (requestParameters['effectiveDate'] == null) {
            throw new runtime.RequiredError(
                'effectiveDate',
                'Required parameter "effectiveDate" was null or undefined when calling getElectionAmount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['effectiveDate'] != null) {
            queryParameters['effective_date'] = requestParameters['effectiveDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/election-amount`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IElectionAmountDtoFromJSON(jsonValue));
    }

    /**
     * Checks election amount.
     */
    async getElectionAmount(requestParameters: GetElectionAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IElectionAmountDto> {
        const response = await this.getElectionAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing plan\'s services grouped by categories
     */
    async getEligibleServicesRaw(requestParameters: GetEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICategoryServiceDto>>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getEligibleServices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['serviceTypes'] != null) {
            queryParameters['service_types'] = requestParameters['serviceTypes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/services`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICategoryServiceDtoFromJSON));
    }

    /**
     * Get all existing plan\'s services grouped by categories
     */
    async getEligibleServices(requestParameters: GetEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICategoryServiceDto>> {
        const response = await this.getEligibleServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get eligible services grouped by policy and category
     */
    async getEligibleServicesByPoliciesRaw(requestParameters: GetEligibleServicesByPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEligibleServicesDto>>> {
        if (requestParameters['policyIds'] == null) {
            throw new runtime.RequiredError(
                'policyIds',
                'Required parameter "policyIds" was null or undefined when calling getEligibleServicesByPolicies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['policyIds'] != null) {
            queryParameters['policy_ids'] = requestParameters['policyIds'];
        }

        if (requestParameters['serviceTypes'] != null) {
            queryParameters['service_types'] = requestParameters['serviceTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPolicyEligibleServicesDtoFromJSON));
    }

    /**
     * Get eligible services grouped by policy and category
     */
    async getEligibleServicesByPolicies(requestParameters: GetEligibleServicesByPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEligibleServicesDto>> {
        const response = await this.getEligibleServicesByPoliciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollment matrixes for given organization path
     */
    async getEnrollmentMatrixesRaw(requestParameters: GetEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEnrollmentMatrixDto>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getEnrollmentMatrixes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollment-matrixes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageEnrollmentMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Get enrollment matrixes for given organization path
     */
    async getEnrollmentMatrixes(requestParameters: GetEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEnrollmentMatrixDto> {
        const response = await this.getEnrollmentMatrixesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get expired enrollment matrixes for given organization path
     */
    async getExpiredEnrollmentMatrixesRaw(requestParameters: GetExpiredEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEnrollmentMatrixDto>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getExpiredEnrollmentMatrixes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollment-matrixes/expired`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageEnrollmentMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Get expired enrollment matrixes for given organization path
     */
    async getExpiredEnrollmentMatrixes(requestParameters: GetExpiredEnrollmentMatrixesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEnrollmentMatrixDto> {
        const response = await this.getExpiredEnrollmentMatrixesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing frequency types
     */
    async getFrequencyTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/frequencies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumTypeDtoFromJSON));
    }

    /**
     * Get all existing frequency types
     */
    async getFrequencyTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>> {
        const response = await this.getFrequencyTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get heath plan details
     */
    async getHealthPlanRaw(requestParameters: GetHealthPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getHealthPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHealthPlanDtoFromJSON));
    }

    /**
     * Get heath plan details
     */
    async getHealthPlan(requestParameters: GetHealthPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanDto>> {
        const response = await this.getHealthPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health plan notes
     */
    async getHealthPlanNotesRaw(requestParameters: GetHealthPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getHealthPlanNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/{id}/notes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get health plan notes
     */
    async getHealthPlanNotes(requestParameters: GetHealthPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getHealthPlanNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get deductible tier statistics (family counts) for Health Plans linked to a plan
     */
    async getHealthPlanTierStatisticsRaw(requestParameters: GetHealthPlanTierStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPlanTierStatsDto>>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getHealthPlanTierStatistics().'
            );
        }

        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getHealthPlanTierStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/health-plan-tier-stats`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHealthPlanTierStatsDtoFromJSON));
    }

    /**
     * Get deductible tier statistics (family counts) for Health Plans linked to a plan
     */
    async getHealthPlanTierStatistics(requestParameters: GetHealthPlanTierStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPlanTierStatsDto>> {
        const response = await this.getHealthPlanTierStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health plan years for employee
     */
    async getHealthPlanYearsByEmployeeRaw(requestParameters: GetHealthPlanYearsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearLiteDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getHealthPlanYearsByEmployee().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/health-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanYearLiteDtoFromJSON));
    }

    /**
     * Get health plan years for employee
     */
    async getHealthPlanYearsByEmployee(requestParameters: GetHealthPlanYearsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearLiteDto>> {
        const response = await this.getHealthPlanYearsByEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health policy
     */
    async getHealthPolicy1Raw(requestParameters: GetHealthPolicy1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHealthPolicyDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getHealthPolicy1().'
            );
        }

        if (requestParameters['healthPlanId'] == null) {
            throw new runtime.RequiredError(
                'healthPlanId',
                'Required parameter "healthPlanId" was null or undefined when calling getHealthPolicy1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['healthPlanId'] != null) {
            queryParameters['health_plan_id'] = requestParameters['healthPlanId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/health-policies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHealthPolicyDtoFromJSON));
    }

    /**
     * Get health policy
     */
    async getHealthPolicy1(requestParameters: GetHealthPolicy1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHealthPolicyDto>> {
        const response = await this.getHealthPolicy1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves IrsLimitTypes by IrsCoverageLevelType without years
     */
    async getIrsMaximumsRaw(requestParameters: GetIrsMaximumsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIrsLimitLiteDto>>> {
        const queryParameters: any = {};

        if (requestParameters['coverageLevelType'] != null) {
            queryParameters['coverage_level_type'] = requestParameters['coverageLevelType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/irs-maximums/types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IIrsLimitLiteDtoFromJSON));
    }

    /**
     * Retrieves IrsLimitTypes by IrsCoverageLevelType without years
     */
    async getIrsMaximums(requestParameters: GetIrsMaximumsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIrsLimitLiteDto>> {
        const response = await this.getIrsMaximumsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get is plan level funding enabled
     */
    async getIsPlanLevelFundingEnabledRaw(requestParameters: GetIsPlanLevelFundingEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getIsPlanLevelFundingEnabled().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-account-funding-config/plan-level-funding/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get is plan level funding enabled
     */
    async getIsPlanLevelFundingEnabled(requestParameters: GetIsPlanLevelFundingEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getIsPlanLevelFundingEnabledRaw(requestParameters, initOverrides);
    }

    /**
     * Get linked system templates
     */
    async getLinkedSystemTemplatesRaw(requestParameters: GetLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getLinkedSystemTemplates().'
            );
        }

        if (requestParameters['onlyLinked'] == null) {
            throw new runtime.RequiredError(
                'onlyLinked',
                'Required parameter "onlyLinked" was null or undefined when calling getLinkedSystemTemplates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['onlyLinked'] != null) {
            queryParameters['only_linked'] = requestParameters['onlyLinked'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/templates/organizations/{organization_id}/linked-templates`;
        urlPath = urlPath.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get linked system templates
     */
    async getLinkedSystemTemplates(requestParameters: GetLinkedSystemTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getLinkedSystemTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all MP tables
     */
    async getMpTablesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IMpTableDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mp-tables`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IMpTableDtoFromJSON));
    }

    /**
     * Get all MP tables
     */
    async getMpTables(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IMpTableDto>> {
        const response = await this.getMpTablesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Organization lock status
     */
    async getOrganizationLockStatusRaw(requestParameters: GetOrganizationLockStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLockDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationLockStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-locks/{organizationId}`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationLockDtoFromJSON(jsonValue));
    }

    /**
     * Get Organization lock status
     */
    async getOrganizationLockStatus(requestParameters: GetOrganizationLockStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLockDto | null | undefined > {
        const response = await this.getOrganizationLockStatusRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get payout definition details
     */
    async getPayoutDefinitionRaw(requestParameters: GetPayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPayoutDefinition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayoutDefinitionDtoFromJSON(jsonValue));
    }

    /**
     * Get payout definition details
     */
    async getPayoutDefinition(requestParameters: GetPayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto> {
        const response = await this.getPayoutDefinitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns id and name of all payout definitions available from the current organization level and higher levels. Intended to populate the \"Copy settings from\" dropdown. No pagination.
     * Get lightweight list of payout definitions for given organization path
     */
    async getPayoutDefinitionsLiteRaw(requestParameters: GetPayoutDefinitionsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIdNameDto>>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getPayoutDefinitionsLite().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/lite`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IIdNameDtoFromJSON));
    }

    /**
     * Returns id and name of all payout definitions available from the current organization level and higher levels. Intended to populate the \"Copy settings from\" dropdown. No pagination.
     * Get lightweight list of payout definitions for given organization path
     */
    async getPayoutDefinitionsLite(requestParameters: GetPayoutDefinitionsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIdNameDto>> {
        const response = await this.getPayoutDefinitionsLiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all payout rule types
     */
    async getPayoutRuleTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/payout-rules`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumTypeDtoFromJSON));
    }

    /**
     * Get all payout rule types
     */
    async getPayoutRuleTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>> {
        const response = await this.getPayoutRuleTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get existing plan by id
     */
    async getPlan1Raw(requestParameters: GetPlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getPlan1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanDtoFromJSON(jsonValue));
    }

    /**
     * Get existing plan by id
     */
    async getPlan1(requestParameters: GetPlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto> {
        const response = await this.getPlan1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing plan by account id
     */
    async getPlanByAccountIdRaw(requestParameters: GetPlanByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getPlanByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanDtoFromJSON(jsonValue));
    }

    /**
     * Get existing plan by account id
     */
    async getPlanByAccountId(requestParameters: GetPlanByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanDto> {
        const response = await this.getPlanByAccountIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plan and template ids within hierarchy
     */
    async getPlanIdsWithinPlanHierarchyRaw(requestParameters: GetPlanIdsWithinPlanHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getPlanIdsWithinPlanHierarchy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['templateId'] != null) {
            queryParameters['template_id'] = requestParameters['templateId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/templates/hierarchy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get plan and template ids within hierarchy
     */
    async getPlanIdsWithinPlanHierarchy(requestParameters: GetPlanIdsWithinPlanHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPlanIdsWithinPlanHierarchyRaw(requestParameters, initOverrides);
    }

    /**
     * Get plan notes
     */
    async getPlanNotesRaw(requestParameters: GetPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPlanNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{id}/notes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get plan notes
     */
    async getPlanNotes(requestParameters: GetPlanNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPlanNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing plan primary config by account id
     */
    async getPlanPrimaryConfigByAccountIdRaw(requestParameters: GetPlanPrimaryConfigByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanPrimaryConfigLiteDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getPlanPrimaryConfigByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/plan-primary-config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanPrimaryConfigLiteDtoFromJSON(jsonValue));
    }

    /**
     * Get existing plan primary config by account id
     */
    async getPlanPrimaryConfigByAccountId(requestParameters: GetPlanPrimaryConfigByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanPrimaryConfigLiteDto> {
        const response = await this.getPlanPrimaryConfigByAccountIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plan templates for payout definition
     */
    async getPlanTemplatesByPayoutDefinitionIdAndServiceIdRaw(requestParameters: GetPlanTemplatesByPayoutDefinitionIdAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayoutDefinitionPlanDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPlanTemplatesByPayoutDefinitionIdAndServiceId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['serviceId'] != null) {
            queryParameters['service_id'] = requestParameters['serviceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/{id}/plans`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayoutDefinitionPlanDtoFromJSON));
    }

    /**
     * Get plan templates for payout definition
     */
    async getPlanTemplatesByPayoutDefinitionIdAndServiceId(requestParameters: GetPlanTemplatesByPayoutDefinitionIdAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayoutDefinitionPlanDto>> {
        const response = await this.getPlanTemplatesByPayoutDefinitionIdAndServiceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plan termination properties
     */
    async getPlanTerminationProperties1Raw(requestParameters: GetPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getPlanTerminationProperties1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/termination-properties`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get plan termination properties
     */
    async getPlanTerminationProperties1(requestParameters: GetPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPlanTerminationProperties1Raw(requestParameters, initOverrides);
    }

    /**
     * Get plan with grace period
     */
    async getPlanWithGracePeriodRaw(requestParameters: GetPlanWithGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanGracePeriodDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getPlanWithGracePeriod().'
            );
        }

        if (requestParameters['terminationDate'] == null) {
            throw new runtime.RequiredError(
                'terminationDate',
                'Required parameter "terminationDate" was null or undefined when calling getPlanWithGracePeriod().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['terminationDate'] != null) {
            queryParameters['termination_date'] = requestParameters['terminationDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/active-grace-period`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanGracePeriodDtoFromJSON(jsonValue));
    }

    /**
     * Get plan with grace period
     */
    async getPlanWithGracePeriod(requestParameters: GetPlanWithGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanGracePeriodDto> {
        const response = await this.getPlanWithGracePeriodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plan year by its ID
     */
    async getPlanYearRaw(requestParameters: GetPlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanYearDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPlanYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanYearDtoFromJSON(jsonValue));
    }

    /**
     * Get plan year by its ID
     */
    async getPlanYear(requestParameters: GetPlanYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanYearDto> {
        const response = await this.getPlanYearRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active plans and plans with an active grace period
     */
    async getPlansWithActiveGracePeriodRaw(requestParameters: GetPlansWithActiveGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanGracePeriodDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getPlansWithActiveGracePeriod().'
            );
        }

        if (requestParameters['terminationDate'] == null) {
            throw new runtime.RequiredError(
                'terminationDate',
                'Required parameter "terminationDate" was null or undefined when calling getPlansWithActiveGracePeriod().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['terminationDate'] != null) {
            queryParameters['termination_date'] = requestParameters['terminationDate'];
        }

        if (requestParameters['planStatuses'] != null) {
            queryParameters['plan_statuses'] = requestParameters['planStatuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/organizations/{organization-id}/active-grace-period`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanGracePeriodDtoFromJSON));
    }

    /**
     * Get active plans and plans with an active grace period
     */
    async getPlansWithActiveGracePeriod(requestParameters: GetPlansWithActiveGracePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanGracePeriodDto>> {
        const response = await this.getPlansWithActiveGracePeriodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing policy by plan id and employee id and account_id
     */
    async getPoliciesByFilterRaw(requestParameters: GetPoliciesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEnrollmentDto>>> {
        const queryParameters: any = {};

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPolicyEnrollmentDtoFromJSON));
    }

    /**
     * Get existing policy by plan id and employee id and account_id
     */
    async getPoliciesByFilter(requestParameters: GetPoliciesByFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEnrollmentDto>> {
        const response = await this.getPoliciesByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all accountIds by employee id and validFrom
     */
    async getPolicyAccountsByFilterRaw(requestParameters: GetPolicyAccountsByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getPolicyAccountsByFilter().'
            );
        }

        if (requestParameters['validFrom'] == null) {
            throw new runtime.RequiredError(
                'validFrom',
                'Required parameter "validFrom" was null or undefined when calling getPolicyAccountsByFilter().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['validFrom'] != null) {
            queryParameters['valid_from'] = (requestParameters['validFrom'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all accountIds by employee id and validFrom
     */
    async getPolicyAccountsByFilter(requestParameters: GetPolicyAccountsByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getPolicyAccountsByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing policy election by id
     */
    async getPolicyElectionRaw(requestParameters: GetPolicyElectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyElectionDto>> {
        if (requestParameters['policyId'] == null) {
            throw new runtime.RequiredError(
                'policyId',
                'Required parameter "policyId" was null or undefined when calling getPolicyElection().'
            );
        }

        if (requestParameters['electionId'] == null) {
            throw new runtime.RequiredError(
                'electionId',
                'Required parameter "electionId" was null or undefined when calling getPolicyElection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/{policy-id}/elections/{election-id}`;
        urlPath = urlPath.replace(`{${"policy-id"}}`, encodeURIComponent(String(requestParameters['policyId'])));
        urlPath = urlPath.replace(`{${"election-id"}}`, encodeURIComponent(String(requestParameters['electionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPolicyElectionDtoFromJSON(jsonValue));
    }

    /**
     * Get existing policy election by id
     */
    async getPolicyElection(requestParameters: GetPolicyElectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyElectionDto> {
        const response = await this.getPolicyElectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get policy spend limits (commuter, person, category) for a given service date
     */
    async getPolicyLimitsRaw(requestParameters: GetPolicyLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicySpendLimitsDto>> {
        if (requestParameters['policyId'] == null) {
            throw new runtime.RequiredError(
                'policyId',
                'Required parameter "policyId" was null or undefined when calling getPolicyLimits().'
            );
        }

        if (requestParameters['serviceOn'] == null) {
            throw new runtime.RequiredError(
                'serviceOn',
                'Required parameter "serviceOn" was null or undefined when calling getPolicyLimits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = (requestParameters['serviceOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceId'] != null) {
            queryParameters['service_id'] = requestParameters['serviceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/{policy-id}/limits`;
        urlPath = urlPath.replace(`{${"policy-id"}}`, encodeURIComponent(String(requestParameters['policyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPolicySpendLimitsDtoFromJSON(jsonValue));
    }

    /**
     * Get policy spend limits (commuter, person, category) for a given service date
     */
    async getPolicyLimits(requestParameters: GetPolicyLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicySpendLimitsDto> {
        const response = await this.getPolicyLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing policy status by id
     */
    async getPolicyStatusRaw(requestParameters: GetPolicyStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyStatusDto>> {
        if (requestParameters['policyId'] == null) {
            throw new runtime.RequiredError(
                'policyId',
                'Required parameter "policyId" was null or undefined when calling getPolicyStatus().'
            );
        }

        if (requestParameters['statusId'] == null) {
            throw new runtime.RequiredError(
                'statusId',
                'Required parameter "statusId" was null or undefined when calling getPolicyStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/{policy-id}/statuses/{status-id}`;
        urlPath = urlPath.replace(`{${"policy-id"}}`, encodeURIComponent(String(requestParameters['policyId'])));
        urlPath = urlPath.replace(`{${"status-id"}}`, encodeURIComponent(String(requestParameters['statusId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPolicyStatusDtoFromJSON(jsonValue));
    }

    /**
     * Get existing policy status by id
     */
    async getPolicyStatus(requestParameters: GetPolicyStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyStatusDto> {
        const response = await this.getPolicyStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get policy statuses history by policy id
     */
    async getPolicyStatusesHistoryRaw(requestParameters: GetPolicyStatusesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyStatusDto>>> {
        if (requestParameters['policyId'] == null) {
            throw new runtime.RequiredError(
                'policyId',
                'Required parameter "policyId" was null or undefined when calling getPolicyStatusesHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/{policyId}/policy-statuses`;
        urlPath = urlPath.replace(`{${"policyId"}}`, encodeURIComponent(String(requestParameters['policyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPolicyStatusDtoFromJSON));
    }

    /**
     * Get policy statuses history by policy id
     */
    async getPolicyStatusesHistory(requestParameters: GetPolicyStatusesHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyStatusDto>> {
        const response = await this.getPolicyStatusesHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prior plan years by organization id and next plan year valid from
     */
    async getPriorPlanYearsRaw(requestParameters: GetPriorPlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getPriorPlanYears().'
            );
        }

        if (requestParameters['nextValidFrom'] == null) {
            throw new runtime.RequiredError(
                'nextValidFrom',
                'Required parameter "nextValidFrom" was null or undefined when calling getPriorPlanYears().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['nextValidFrom'] != null) {
            queryParameters['next_valid_from'] = requestParameters['nextValidFrom'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/priors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanYearDtoFromJSON));
    }

    /**
     * Get prior plan years by organization id and next plan year valid from
     */
    async getPriorPlanYears(requestParameters: GetPriorPlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>> {
        const response = await this.getPriorPlanYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prior plans by plan year id and account type
     */
    async getPriorPlansRaw(requestParameters: GetPriorPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPriorPlanDto>>> {
        if (requestParameters['planYearId'] == null) {
            throw new runtime.RequiredError(
                'planYearId',
                'Required parameter "planYearId" was null or undefined when calling getPriorPlans().'
            );
        }

        if (requestParameters['accountType'] == null) {
            throw new runtime.RequiredError(
                'accountType',
                'Required parameter "accountType" was null or undefined when calling getPriorPlans().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['planYearId'] != null) {
            queryParameters['plan_year_id'] = requestParameters['planYearId'];
        }

        if (requestParameters['accountType'] != null) {
            queryParameters['account_type'] = requestParameters['accountType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/priors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPriorPlanDtoFromJSON));
    }

    /**
     * Get prior plans by plan year id and account type
     */
    async getPriorPlans(requestParameters: GetPriorPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPriorPlanDto>> {
        const response = await this.getPriorPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find processing rule by id
     */
    async getProcessingRuleByIdRaw(requestParameters: GetProcessingRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProcessingRuleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProcessingRuleDtoFromJSON(jsonValue));
    }

    /**
     * Find processing rule by id
     */
    async getProcessingRuleById(requestParameters: GetProcessingRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto> {
        const response = await this.getProcessingRuleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get processing rules for given organization path
     */
    async getProcessingRulesRaw(requestParameters: GetProcessingRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageProcessingRuleDto>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getProcessingRules().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['isUsed'] != null) {
            queryParameters['is_used'] = requestParameters['isUsed'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageProcessingRuleDtoFromJSON(jsonValue));
    }

    /**
     * Get processing rules for given organization path
     */
    async getProcessingRules(requestParameters: GetProcessingRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageProcessingRuleDto> {
        const response = await this.getProcessingRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing proof of expenses options
     */
    async getProofOfExpensesOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/proof-of-expenses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumTypeDtoFromJSON));
    }

    /**
     * Get all existing proof of expenses options
     */
    async getProofOfExpensesOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>> {
        const response = await this.getProofOfExpensesOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get plans eligible for reactivation by organization id
     */
    async getReactivationEligiblePlansRaw(requestParameters: GetReactivationEligiblePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getReactivationEligiblePlans().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/organizations/{organization-id}/reactivation-eligible`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanDtoFromJSON));
    }

    /**
     * Get plans eligible for reactivation by organization id
     */
    async getReactivationEligiblePlans(requestParameters: GetReactivationEligiblePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanDto>> {
        const response = await this.getReactivationEligiblePlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve reduced policies by account ids
     */
    async getReducedPoliciesRaw(requestParameters: GetReducedPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IReducedPolicyDto>>> {
        if (requestParameters['accountIds'] == null) {
            throw new runtime.RequiredError(
                'accountIds',
                'Required parameter "accountIds" was null or undefined when calling getReducedPolicies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountIds'] != null) {
            queryParameters['account_ids'] = requestParameters['accountIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/reduced`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(IReducedPolicyDtoFromJSON)));
    }

    /**
     * Retrieve reduced policies by account ids
     */
    async getReducedPolicies(requestParameters: GetReducedPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IReducedPolicyDto>> {
        const response = await this.getReducedPoliciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all sequences for organization
     */
    async getSequenceByIdRaw(requestParameters: GetSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSequenceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sequences/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISequenceDtoFromJSON(jsonValue));
    }

    /**
     * Get all sequences for organization
     */
    async getSequenceById(requestParameters: GetSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto> {
        const response = await this.getSequenceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get service by id
     */
    async getServiceByIdRaw(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getServiceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IServiceDtoFromJSON(jsonValue));
    }

    /**
     * Get service by id
     */
    async getServiceById(requestParameters: GetServiceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto> {
        const response = await this.getServiceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing service category types
     */
    async getServiceCategoryTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/service-categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumTypeDtoFromJSON));
    }

    /**
     * Get all existing service category types
     */
    async getServiceCategoryTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>> {
        const response = await this.getServiceCategoryTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of service configs for given health plan
     */
    async getServiceConfigsRaw(requestParameters: GetServiceConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceConfigDto>>> {
        if (requestParameters['healthPlanId'] == null) {
            throw new runtime.RequiredError(
                'healthPlanId',
                'Required parameter "healthPlanId" was null or undefined when calling getServiceConfigs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['healthPlanId'] != null) {
            queryParameters['health_plan_id'] = requestParameters['healthPlanId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/service-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IServiceConfigDtoFromJSON));
    }

    /**
     * Get list of service configs for given health plan
     */
    async getServiceConfigs(requestParameters: GetServiceConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceConfigDto>> {
        const response = await this.getServiceConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get services by name and employee_id
     */
    async getServicesRaw(requestParameters: GetServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceDto>>> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['serviceTypes'] != null) {
            queryParameters['service_types'] = requestParameters['serviceTypes'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = requestParameters['serviceOn'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IServiceDtoFromJSON));
    }

    /**
     * Get services by name and employee_id
     */
    async getServices(requestParameters: GetServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceDto>> {
        const response = await this.getServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get services for payout definition
     */
    async getServicesByFilterRaw(requestParameters: GetServicesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayoutDefinitionServiceDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getServicesByFilter().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/{id}/services`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayoutDefinitionServiceDtoFromJSON));
    }

    /**
     * Get services for payout definition
     */
    async getServicesByFilter(requestParameters: GetServicesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayoutDefinitionServiceDto>> {
        const response = await this.getServicesByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get spend limit periods for account_id
     */
    async getSpendLimitPeriodForAccountRaw(requestParameters: GetSpendLimitPeriodForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitPeriodDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getSpendLimitPeriodForAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/spend-limit-periods/{account-id}`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISpendLimitPeriodDtoFromJSON(jsonValue));
    }

    /**
     * Get spend limit periods for account_id
     */
    async getSpendLimitPeriodForAccount(requestParameters: GetSpendLimitPeriodForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitPeriodDto> {
        const response = await this.getSpendLimitPeriodForAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get spend limit periods remaining
     */
    async getSpendLimitPeriodsRemainingRaw(requestParameters: GetSpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitPeriodRemainingDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getSpendLimitPeriodsRemaining().'
            );
        }

        if (requestParameters['periodFrom'] == null) {
            throw new runtime.RequiredError(
                'periodFrom',
                'Required parameter "periodFrom" was null or undefined when calling getSpendLimitPeriodsRemaining().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = requestParameters['periodFrom'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/spend-limit-periods/{account-id}/remaining`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISpendLimitPeriodRemainingDtoFromJSON(jsonValue));
    }

    /**
     * Get spend limit periods remaining
     */
    async getSpendLimitPeriodsRemaining(requestParameters: GetSpendLimitPeriodsRemainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitPeriodRemainingDto> {
        const response = await this.getSpendLimitPeriodsRemainingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get spend limit remaining by account(s)
     */
    async getSpendLimitRemainingByAccountRaw(requestParameters: GetSpendLimitRemainingByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISpendLimitRemainingByAccountDto>> {
        if (requestParameters['accountIds'] == null) {
            throw new runtime.RequiredError(
                'accountIds',
                'Required parameter "accountIds" was null or undefined when calling getSpendLimitRemainingByAccount().'
            );
        }

        if (requestParameters['periodFrom'] == null) {
            throw new runtime.RequiredError(
                'periodFrom',
                'Required parameter "periodFrom" was null or undefined when calling getSpendLimitRemainingByAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountIds'] != null) {
            queryParameters['account_ids'] = requestParameters['accountIds'];
        }

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = (requestParameters['periodFrom'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/spend-limit-periods/remaining`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISpendLimitRemainingByAccountDtoFromJSON(jsonValue));
    }

    /**
     * Get spend limit remaining by account(s)
     */
    async getSpendLimitRemainingByAccount(requestParameters: GetSpendLimitRemainingByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISpendLimitRemainingByAccountDto> {
        const response = await this.getSpendLimitRemainingByAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get templates
     */
    async getTemplatesRaw(requestParameters: GetTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanTemplateConfigDto>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['planStatus'] != null) {
            queryParameters['plan_status'] = requestParameters['planStatus'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanTemplateConfigDtoFromJSON(jsonValue));
    }

    /**
     * Get templates
     */
    async getTemplates(requestParameters: GetTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanTemplateConfigDto> {
        const response = await this.getTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing triggers
     */
    async getTriggerTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/triggers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumTypeDtoFromJSON));
    }

    /**
     * Get all existing triggers
     */
    async getTriggerTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumTypeDto>> {
        const response = await this.getTriggerTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get triggers by organization path and optional trigger category type
     */
    async getTriggersRaw(requestParameters: GetTriggersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageTriggerDto>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getTriggers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/triggers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageTriggerDtoFromJSON(jsonValue));
    }

    /**
     * Get triggers by organization path and optional trigger category type
     */
    async getTriggers(requestParameters: GetTriggersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageTriggerDto> {
        const response = await this.getTriggersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if the employee has any active health policy on the given effective date
     */
    async healthPolicyExistsForEmployeeOnAGivenDate1Raw(requestParameters: HealthPolicyExistsForEmployeeOnAGivenDate1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling healthPolicyExistsForEmployeeOnAGivenDate1().'
            );
        }

        if (requestParameters['effectiveDate'] == null) {
            throw new runtime.RequiredError(
                'effectiveDate',
                'Required parameter "effectiveDate" was null or undefined when calling healthPolicyExistsForEmployeeOnAGivenDate1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['effectiveDate'] != null) {
            queryParameters['effective_date'] = (requestParameters['effectiveDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludedHealthPlanId'] != null) {
            queryParameters['excluded_health_plan_id'] = requestParameters['excludedHealthPlanId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/health-plans/health-policies/exists`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check if the employee has any active health policy on the given effective date
     */
    async healthPolicyExistsForEmployeeOnAGivenDate1(requestParameters: HealthPolicyExistsForEmployeeOnAGivenDate1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.healthPolicyExistsForEmployeeOnAGivenDate1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch enrollment matrix by id
     */
    async patchEnrollmentMatrixRaw(requestParameters: PatchEnrollmentMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEnrollmentMatrixDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling patchEnrollmentMatrix().'
            );
        }

        if (requestParameters['iEnrollmentMatrixPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iEnrollmentMatrixPatchDto',
                'Required parameter "iEnrollmentMatrixPatchDto" was null or undefined when calling patchEnrollmentMatrix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enrollment-matrixes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IEnrollmentMatrixPatchDtoToJSON(requestParameters['iEnrollmentMatrixPatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEnrollmentMatrixDtoFromJSON(jsonValue));
    }

    /**
     * Patch enrollment matrix by id
     */
    async patchEnrollmentMatrix(requestParameters: PatchEnrollmentMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEnrollmentMatrixDto> {
        const response = await this.patchEnrollmentMatrixRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update plan termination properties
     */
    async patchPlanTerminationProperties1Raw(requestParameters: PatchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling patchPlanTerminationProperties1().'
            );
        }

        if (requestParameters['iPlanTerminationPropertiesPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iPlanTerminationPropertiesPatchDto',
                'Required parameter "iPlanTerminationPropertiesPatchDto" was null or undefined when calling patchPlanTerminationProperties1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/{plan-id}/termination-properties`;
        urlPath = urlPath.replace(`{${"plan-id"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanTerminationPropertiesPatchDtoToJSON(requestParameters['iPlanTerminationPropertiesPatchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update plan termination properties
     */
    async patchPlanTerminationProperties1(requestParameters: PatchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchPlanTerminationProperties1Raw(requestParameters, initOverrides);
    }

    /**
     * Preview deductible update
     */
    async previewDeductiblesUpdateRaw(requestParameters: PreviewDeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling previewDeductiblesUpdate().'
            );
        }

        if (requestParameters['iDeductiblePreviewRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iDeductiblePreviewRequestDto',
                'Required parameter "iDeductiblePreviewRequestDto" was null or undefined when calling previewDeductiblesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/deductibles/employees/{employee-id}/preview`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDeductiblePreviewRequestDtoToJSON(requestParameters['iDeductiblePreviewRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Preview deductible update
     */
    async previewDeductiblesUpdate(requestParameters: PreviewDeductiblesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.previewDeductiblesUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Reactivate terminated or termination-in-progress plans
     */
    async reactivatePlansRaw(requestParameters: ReactivatePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iPlanReactivationDto'] == null) {
            throw new runtime.RequiredError(
                'iPlanReactivationDto',
                'Required parameter "iPlanReactivationDto" was null or undefined when calling reactivatePlans().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/reactivation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanReactivationDtoToJSON(requestParameters['iPlanReactivationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate terminated or termination-in-progress plans
     */
    async reactivatePlans(requestParameters: ReactivatePlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reactivatePlansRaw(requestParameters, initOverrides);
    }

    /**
     * Search person spend limits for Employee (including all his dependents) by account id and period
     */
    async searchPersonSpendLimitsRaw(requestParameters: SearchPersonSpendLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPersonSpendLimitDto>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling searchPersonSpendLimits().'
            );
        }

        if (requestParameters['periodFrom'] == null) {
            throw new runtime.RequiredError(
                'periodFrom',
                'Required parameter "periodFrom" was null or undefined when calling searchPersonSpendLimits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['periodFrom'] != null) {
            queryParameters['period_from'] = requestParameters['periodFrom'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/person-spend-limits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPersonSpendLimitDtoFromJSON));
    }

    /**
     * Search person spend limits for Employee (including all his dependents) by account id and period
     */
    async searchPersonSpendLimits(requestParameters: SearchPersonSpendLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPersonSpendLimitDto>> {
        const response = await this.searchPersonSpendLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search plan termination properties
     */
    async searchPlanTerminationProperties1Raw(requestParameters: SearchPlanTerminationProperties1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['planStatuses'] != null) {
            queryParameters['plan_statuses'] = requestParameters['planStatuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/termination-properties`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Search plan termination properties
     */
    async searchPlanTerminationProperties1(requestParameters: SearchPlanTerminationProperties1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.searchPlanTerminationProperties1Raw(requestParameters, initOverrides);
    }

    /**
     * Get plan years by request params
     */
    async searchPlanYearsListRaw(requestParameters: SearchPlanYearsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearDto>>> {
        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling searchPlanYearsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['nextValidFrom'] != null) {
            queryParameters['next_valid_from'] = requestParameters['nextValidFrom'];
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-years/list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanYearDtoFromJSON));
    }

    /**
     * Get plan years by request params
     */
    async searchPlanYearsList(requestParameters: SearchPlanYearsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearDto>> {
        const response = await this.searchPlanYearsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search policies for balance reminder banner
     */
    async searchPoliciesBalanceReminderRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceReminderDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/balance-reminder`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IBalanceReminderDtoFromJSON(jsonValue));
    }

    /**
     * Search policies for balance reminder banner
     */
    async searchPoliciesBalanceReminder(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceReminderDto> {
        const response = await this.searchPoliciesBalanceReminderRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves IrsLimit by employee plan
     */
    async searchPolicyLimitByEmployeePlan1Raw(requestParameters: SearchPolicyLimitByEmployeePlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyLimitsDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling searchPolicyLimitByEmployeePlan1().'
            );
        }

        if (requestParameters['taxYear'] == null) {
            throw new runtime.RequiredError(
                'taxYear',
                'Required parameter "taxYear" was null or undefined when calling searchPolicyLimitByEmployeePlan1().'
            );
        }

        if (requestParameters['birthDate'] == null) {
            throw new runtime.RequiredError(
                'birthDate',
                'Required parameter "birthDate" was null or undefined when calling searchPolicyLimitByEmployeePlan1().'
            );
        }

        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling searchPolicyLimitByEmployeePlan1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['taxYear'] != null) {
            queryParameters['tax_year'] = requestParameters['taxYear'];
        }

        if (requestParameters['birthDate'] != null) {
            queryParameters['birth_date'] = (requestParameters['birthDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['contributionDate'] != null) {
            queryParameters['contribution_date'] = (requestParameters['contributionDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/irs-maximums/employee/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPolicyLimitsDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves IrsLimit by employee plan
     */
    async searchPolicyLimitByEmployeePlan1(requestParameters: SearchPolicyLimitByEmployeePlan1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyLimitsDto> {
        const response = await this.searchPolicyLimitByEmployeePlan1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated services filtered by category types, service types and name.
     * Search services with pagination and filtering
     */
    async searchServicesRaw(requestParameters: SearchServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IServiceDto>>> {
        const queryParameters: any = {};

        if (requestParameters['categoryTypes'] != null) {
            queryParameters['category_types'] = requestParameters['categoryTypes'];
        }

        if (requestParameters['serviceTypes'] != null) {
            queryParameters['service_types'] = requestParameters['serviceTypes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/services/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IServiceDtoFromJSON));
    }

    /**
     * Returns paginated services filtered by category types, service types and name.
     * Search services with pagination and filtering
     */
    async searchServices(requestParameters: SearchServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IServiceDto>> {
        const response = await this.searchServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update copay group
     */
    async updateCopayGroupRaw(requestParameters: UpdateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICopayGroupDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCopayGroup().'
            );
        }

        if (requestParameters['iCopayGroupDto'] == null) {
            throw new runtime.RequiredError(
                'iCopayGroupDto',
                'Required parameter "iCopayGroupDto" was null or undefined when calling updateCopayGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/copay-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICopayGroupDtoToJSON(requestParameters['iCopayGroupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICopayGroupDtoFromJSON(jsonValue));
    }

    /**
     * Update copay group
     */
    async updateCopayGroup(requestParameters: UpdateCopayGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICopayGroupDto> {
        const response = await this.updateCopayGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Plan Account Funding Configs
     */
    async updateIsPlanLevelFundingByPlanIdsRaw(requestParameters: UpdateIsPlanLevelFundingByPlanIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IFundingLevelSwitchingDto>>> {
        if (requestParameters['iPlanIdsDto'] == null) {
            throw new runtime.RequiredError(
                'iPlanIdsDto',
                'Required parameter "iPlanIdsDto" was null or undefined when calling updateIsPlanLevelFundingByPlanIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-account-funding-config/plan-level-funding`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanIdsDtoToJSON(requestParameters['iPlanIdsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IFundingLevelSwitchingDtoFromJSON));
    }

    /**
     * Update Plan Account Funding Configs
     */
    async updateIsPlanLevelFundingByPlanIds(requestParameters: UpdateIsPlanLevelFundingByPlanIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IFundingLevelSwitchingDto>> {
        const response = await this.updateIsPlanLevelFundingByPlanIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payout definition
     */
    async updatePayoutDefinitionRaw(requestParameters: UpdatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayoutDefinitionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePayoutDefinition().'
            );
        }

        if (requestParameters['iPayoutDefinitionUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iPayoutDefinitionUpdateDto',
                'Required parameter "iPayoutDefinitionUpdateDto" was null or undefined when calling updatePayoutDefinition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payout-definitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPayoutDefinitionUpdateDtoToJSON(requestParameters['iPayoutDefinitionUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayoutDefinitionDtoFromJSON(jsonValue));
    }

    /**
     * Update payout definition
     */
    async updatePayoutDefinition(requestParameters: UpdatePayoutDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayoutDefinitionDto> {
        const response = await this.updatePayoutDefinitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update processing rule
     */
    async updateProcessingRuleRaw(requestParameters: UpdateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProcessingRuleDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProcessingRule().'
            );
        }

        if (requestParameters['iProcessingRuleDto'] == null) {
            throw new runtime.RequiredError(
                'iProcessingRuleDto',
                'Required parameter "iProcessingRuleDto" was null or undefined when calling updateProcessingRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IProcessingRuleDtoToJSON(requestParameters['iProcessingRuleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProcessingRuleDtoFromJSON(jsonValue));
    }

    /**
     * Update processing rule
     */
    async updateProcessingRule(requestParameters: UpdateProcessingRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProcessingRuleDto> {
        const response = await this.updateProcessingRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk update of processing rule\'s tiers: payout rule type and Lock Card Purse configuration
     */
    async updateProcessingRuleTiersRaw(requestParameters: UpdateProcessingRuleTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProcessingRuleTiers().'
            );
        }

        if (requestParameters['iUpdateProcessingRuleTiersDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdateProcessingRuleTiersDto',
                'Required parameter "iUpdateProcessingRuleTiersDto" was null or undefined when calling updateProcessingRuleTiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateProcessingRuleTiersDtoToJSON(requestParameters['iUpdateProcessingRuleTiersDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bulk update of processing rule\'s tiers: payout rule type and Lock Card Purse configuration
     */
    async updateProcessingRuleTiers(requestParameters: UpdateProcessingRuleTiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProcessingRuleTiersRaw(requestParameters, initOverrides);
    }

    /**
     * Update processing rule\'s tiers payout rules. Deprecated: use PATCH /processing-rules/{id}
     * @deprecated
     */
    async updateProcessingRulesPayoutRulesRaw(requestParameters: UpdateProcessingRulesPayoutRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProcessingRulesPayoutRules().'
            );
        }

        if (requestParameters['iUpdatePayoutRuleTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdatePayoutRuleTypeRequestDto',
                'Required parameter "iUpdatePayoutRuleTypeRequestDto" was null or undefined when calling updateProcessingRulesPayoutRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/processing-rules/{id}/payout-rules`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdatePayoutRuleTypeRequestDtoToJSON(requestParameters['iUpdatePayoutRuleTypeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update processing rule\'s tiers payout rules. Deprecated: use PATCH /processing-rules/{id}
     * @deprecated
     */
    async updateProcessingRulesPayoutRules(requestParameters: UpdateProcessingRulesPayoutRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProcessingRulesPayoutRulesRaw(requestParameters, initOverrides);
    }

    /**
     * Update sequence
     */
    async updateSequenceByIdRaw(requestParameters: UpdateSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISequenceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSequenceById().'
            );
        }

        if (requestParameters['iSequenceDto'] == null) {
            throw new runtime.RequiredError(
                'iSequenceDto',
                'Required parameter "iSequenceDto" was null or undefined when calling updateSequenceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sequences/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ISequenceDtoToJSON(requestParameters['iSequenceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISequenceDtoFromJSON(jsonValue));
    }

    /**
     * Update sequence
     */
    async updateSequenceById(requestParameters: UpdateSequenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISequenceDto> {
        const response = await this.updateSequenceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing service
     */
    async updateServiceRaw(requestParameters: UpdateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateService().'
            );
        }

        if (requestParameters['iServiceUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'iServiceUpdateRequest',
                'Required parameter "iServiceUpdateRequest" was null or undefined when calling updateService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/services/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IServiceUpdateRequestToJSON(requestParameters['iServiceUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IServiceDtoFromJSON(jsonValue));
    }

    /**
     * Update an existing service
     */
    async updateService(requestParameters: UpdateServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceDto> {
        const response = await this.updateServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update service config
     */
    async updateServiceConfigRaw(requestParameters: UpdateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IServiceConfigDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateServiceConfig().'
            );
        }

        if (requestParameters['iServiceConfigDto'] == null) {
            throw new runtime.RequiredError(
                'iServiceConfigDto',
                'Required parameter "iServiceConfigDto" was null or undefined when calling updateServiceConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/service-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IServiceConfigDtoToJSON(requestParameters['iServiceConfigDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IServiceConfigDtoFromJSON(jsonValue));
    }

    /**
     * Update service config
     */
    async updateServiceConfig(requestParameters: UpdateServiceConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IServiceConfigDto> {
        const response = await this.updateServiceConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate plan codes availability within organization
     */
    async validatePlanCodesRaw(requestParameters: ValidatePlanCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanCodeValidationResponseDto>>> {
        if (requestParameters['iPlanCodeValidationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPlanCodeValidationRequestDto',
                'Required parameter "iPlanCodeValidationRequestDto" was null or undefined when calling validatePlanCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plans/plan-codes/validations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPlanCodeValidationRequestDtoToJSON(requestParameters['iPlanCodeValidationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanCodeValidationResponseDtoFromJSON));
    }

    /**
     * Validate plan codes availability within organization
     */
    async validatePlanCodes(requestParameters: ValidatePlanCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanCodeValidationResponseDto>> {
        const response = await this.validatePlanCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate policy existence with the same fund id
     */
    async validatePolicyExistenceWithSameFundIdRaw(requestParameters: ValidatePolicyExistenceWithSameFundIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPolicyFundIdResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling validatePolicyExistenceWithSameFundId().'
            );
        }

        if (requestParameters['fundId'] == null) {
            throw new runtime.RequiredError(
                'fundId',
                'Required parameter "fundId" was null or undefined when calling validatePolicyExistenceWithSameFundId().'
            );
        }

        if (requestParameters['validFrom'] == null) {
            throw new runtime.RequiredError(
                'validFrom',
                'Required parameter "validFrom" was null or undefined when calling validatePolicyExistenceWithSameFundId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['fundId'] != null) {
            queryParameters['fund_id'] = requestParameters['fundId'];
        }

        if (requestParameters['planId'] != null) {
            queryParameters['plan_id'] = requestParameters['planId'];
        }

        if (requestParameters['validFrom'] != null) {
            queryParameters['valid_from'] = (requestParameters['validFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['validTo'] != null) {
            queryParameters['valid_to'] = (requestParameters['validTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/policies/fund-id`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPolicyFundIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Validate policy existence with the same fund id
     */
    async validatePolicyExistenceWithSameFundId(requestParameters: ValidatePolicyExistenceWithSameFundIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPolicyFundIdResponseDto> {
        const response = await this.validatePolicyExistenceWithSameFundIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetAllCopayGroupsCopayStatusEnum {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllHealthPlanTemplatesPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllHealthPlansPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllIrsLimitsCoverageLevelEnum {
    FAMILY = 'FAMILY',
    INDIVIDUAL = 'INDIVIDUAL',
    ROLLOVER = 'ROLLOVER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllIrsLimitsTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllIrsLimitsFrequencyTypeEnum {
    MONTHLY = 'MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllPlans1PlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllPlans1PlanStatusesEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAllPlans1AccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCategoryServicesCategoriesEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCategoryServicesServiceTypesEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDeductibleServicesServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDeductiblesDeductibleTypeEnum {
    INDIVIDUAL_DEDUCTIBLE_MET = 'INDIVIDUAL_DEDUCTIBLE_MET',
    FAMILY_DEDUCTIBLE_MET = 'FAMILY_DEDUCTIBLE_MET'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEligibleServicesServiceTypesEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEligibleServicesCategoriesEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEligibleServicesByPoliciesServiceTypesEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetIrsMaximumsCoverageLevelTypeEnum {
    FAMILY = 'FAMILY',
    INDIVIDUAL = 'INDIVIDUAL',
    ROLLOVER = 'ROLLOVER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPlansWithActiveGracePeriodPlanStatusesEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPriorPlansAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetServicesServiceTypesEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetServicesByFilterTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetServicesByFilterCategoriesEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTemplatesPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTriggersTypeEnum {
    EXTERNAL = 'EXTERNAL',
    FAMILY = 'FAMILY',
    EMBEDDED = 'EMBEDDED'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchPlanTerminationProperties1PlanStatusesEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchServicesCategoryTypesEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchServicesServiceTypesEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}
